export function ChevronUp() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path
        fill="#DF508B"
        d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6l-6 6l1.41 1.41Z"
      />
    </svg>
  );
}

export function ChevronDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6l1.41-1.42Z"
      />
    </svg>
  );
}

export function Hamburger() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5 17h14M5 12h14M5 7h14"
      />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0c.41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
      />
    </svg>
  );
}

export function LogoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 21q-.825 0-1.413-.588T3 19V5q0-.825.588-1.413T5 3h7v2H5v14h7v2H5Zm11-4l-1.375-1.45l2.55-2.55H9v-2h8.175l-2.55-2.55L16 7l5 5l-5 5Z"
      />
    </svg>
  );
}

export function PhoneIcon({state}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 256 256">
      <path
        fill={state?.callCenter ? '#DF508B' : 'currentColor'}
        d="M152.27 37.93a8 8 0 0 1 9.8-5.66a86.22 86.22 0 0 1 61.66 61.66a8 8 0 0 1-5.66 9.8a8.23 8.23 0 0 1-2.07.27a8 8 0 0 1-7.73-5.94a70.35 70.35 0 0 0-50.33-50.33a8 8 0 0 1-5.67-9.8Zm-2.33 41.8c13.79 3.68 22.65 12.54 26.33 26.33A8 8 0 0 0 184 112a8.23 8.23 0 0 0 2.07-.27a8 8 0 0 0 5.66-9.8c-5.12-19.16-18.5-32.54-37.66-37.66a8 8 0 1 0-4.13 15.46Zm81.94 95.35A56.26 56.26 0 0 1 176 224C96.6 224 32 159.4 32 80a56.26 56.26 0 0 1 48.92-55.88a16 16 0 0 1 16.62 9.52l21.12 47.15v.12A16 16 0 0 1 117.39 96c-.18.27-.37.52-.57.77L96 121.45c7.49 15.22 23.41 31 38.83 38.51l24.34-20.71a8.12 8.12 0 0 1 .75-.56a16 16 0 0 1 15.17-1.4l.13.06l47.11 21.11a16 16 0 0 1 9.55 16.62Zm-15.88-2h-.11l-47-21.05l-24.35 20.71a8.44 8.44 0 0 1-.74.56a16 16 0 0 1-15.75 1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16 16 0 0 1 1-15.7a6.13 6.13 0 0 1 .57-.77L104 87.15l-21-47a.61.61 0 0 1 0-.12A40.2 40.2 0 0 0 48 80a128.14 128.14 0 0 0 128 128a40.21 40.21 0 0 0 40-34.93Z"
      />
    </svg>
  );
}

export function DefinedMaster({state}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48">
      <path
        fill={state?.definedMaster ? '#DF508B' : 'currentColor'}
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.61 14.45v3.49m0-3.49v-1.73h.65h-1.29h.64m1.64 1.73h-3.27"
      />
      <path
        fill={state?.definedMaster ? '#DF508B' : 'currentColor'}
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M40.5 5.5h-33a2 2 0 0 0-2 2v33a2 2 0 0 0 2 2h33a2 2 0 0 0 2-2v-33a2 2 0 0 0-2-2ZM24 5.5v37"
      />
      <path
        fill={state?.definedMaster ? '#DF508B' : 'currentColor'}
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M37.482 38.483a.3.3 0 0 0 .3-.3v-.02c-.05-1.87-2.5-2-1.25-2.16c.65-.1 1.68-.85.85-1.71s-1.22-.67-.87-1s2-1.95.92-2.29c-1.6-.51-1-.7-.92-.77a2.9 2.9 0 0 0 1.61-2.28a.27.27 0 0 0-.48-.2c-.4.46-4 1.73-9.42 1.7c-.76.11-.37.91-.28 1.8c.06.54.9.65 1.28.61c.2 0 1.21-.13 1.36-.11c.64.08.79.57 1 1a2 2 0 0 0 1.92.88c.13 0-.25.15-1.13.14c-1.52 0-3.45 1.73-4.06 4.19a.39.39 0 0 0 .3.462a.396.396 0 0 0 .05.008c1.54.09 7.27.03 8.82.05Z"
      />
      <path
        fill={state?.definedMaster ? '#DF508B' : 'currentColor'}
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M33.452 30.773a2.12 2.12 0 0 0 .94-.15a3.6 3.6 0 0 0-.94.15ZM14.58 20.35h-4.27s-3.87-7 4.25-11.78h0c8.12 4.82 4.26 11.78 4.26 11.78ZM5.5 24h37"
      />
    </svg>
  );
}

export function DashabordIcon({state}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 32 32">
      <path
        fill={state?.dashboard ? '#DF508B' : 'currentColor'}
        d="M24 21h2v5h-2zm-4-5h2v10h-2zm-9 10a5.006 5.006 0 0 1-5-5h2a3 3 0 1 0 3-3v-2a5 5 0 0 1 0 10z"
      />
      <path
        fill={state?.dashboard ? '#DF508B' : 'currentColor'}
        d="M28 2H4a2.002 2.002 0 0 0-2 2v24a2.002 2.002 0 0 0 2 2h24a2.003 2.003 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2Zm0 9H14V4h14ZM12 4v7H4V4ZM4 28V13h24l.002 15Z"
      />
    </svg>
  );
}

export function CompanyMasterSetup({state}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48">
      <path
        fill="none"
        stroke={state?.masterSetup ? '#DF508B' : 'currentColor'}
        // stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.6 14.4v3.5m0-3.5v-1.7h.7H14h.6m1.6 1.7H13"
      />
      <path
        fill="none"
        // stroke="currentColor"
        stroke={state?.masterSetup ? '#DF508B' : 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M40.5 5.5h-33c-1.1 0-2 .9-2 2v33c0 1.1.9 2 2 2h33c1.1 0 2-.9 2-2v-33c0-1.1-.9-2-2-2ZM24 5.5v37"
      />
      <path
        fill="none"
        // stroke="currentColor"
        stroke={state?.masterSetup ? '#DF508B' : 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M37.2 38.2c.2 0 .3-.1.3-.3h0c0-1.9-2.5-2-1.2-2.2c.7-.1 1.7-.8.8-1.7s-1.2-.7-.9-1s2-2 .9-2.3c-1.6-.5-1-.7-.9-.8c.9-.4 1.5-1.3 1.6-2.3c0-.1-.1-.3-.2-.3s-.2 0-.2.1c-.4.5-4 1.7-9.4 1.7c-.8.1-.4.9-.3 1.8c.1.5.9.6 1.3.6c.2 0 1.2-.1 1.4-.1c.6.1.8.6 1 1c.4.6 1.2 1 1.9.9c.1 0-.2.2-1.1.1c-1.5 0-3.5 1.7-4.1 4.2c0 .2.1.4.3.5h0c1.5.1 7.2 0 8.8.1Z"
      />
      <path
        fill="none"
        // stroke="currentColor"
        stroke={state?.masterSetup ? '#DF508B' : 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M33.1 30.4c.3 0 .6 0 .9-.1c-.3 0-.6 0-.9.1Zm-18.5-10h-4.3s-3.9-7 4.2-11.8h0c8.1 4.8 4.3 11.8 4.3 11.8h-4.2ZM5.5 24h37m-5-11.2c.1 1.5-1 2.9-2.5 3c-.8.1-1.6-.2-2.1-.7c-.5-.4-.8-1.1-.9-1.8c-.1-1.5 1-2.9 2.5-3s2.8.9 3 2.5Zm-4.9 2.3l-3 3.3l-.9 1m2.4.3l-1.5-1.3"
      />
    </svg>
  );
}
export function CustomerEnrolment({state}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 2048 2048">
      <path
        fill={state?.enrolment ? '#DF508B' : 'currentColor'}
        d="M1848 896q42 0 78 15t64 42t42 63t16 78q0 39-15 76t-43 65l-717 719l-377 94l94-377l717-718q28-28 65-42t76-15zm51 249q21-21 21-51q0-31-20-50t-52-20q-14 0-27 4t-23 15l-692 694l-34 135l135-34l692-693zM640 896H512V768h128v128zm896 0H768V768h768v128zM512 1152h128v128H512v-128zm128-640H512V384h128v128zm896 0H768V384h768v128zM384 1664h443l-32 128H256V0h1536v743q-67 10-128 44V128H384v1536zm384-512h514l-128 128H768v-128z"
      />
    </svg>
  );
}

export function ViewPen() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 32 32">
      <path
        fill="#bf8d2c"
        d="M23.906 3.969A4.097 4.097 0 0 0 21 5.188L5.187 21l-.062.313l-1.094 5.5l-.312 1.468l1.469-.312l5.5-1.094l.312-.063L26.813 11a4.075 4.075 0 0 0 0-5.813a4.097 4.097 0 0 0-2.907-1.218zm0 1.906c.504 0 1.012.23 1.5.719c.973.972.973 2.027 0 3l-.718.687l-2.97-2.969l.688-.718c.489-.489.996-.719 1.5-.719zm-3.593 2.844l2.968 2.969L11.188 23.78a6.813 6.813 0 0 0-2.97-2.968zM6.938 22.438a4.734 4.734 0 0 1 2.625 2.625l-3.282.656z"
      />
    </svg>
  );
}

export function Cart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32">
      <path
        fill="#fff"
        d="M29.02 11.754L8.416 9.474L7.16 4.715a.758.758 0 0 0-.727-.558H3.34a1.214 1.214 0 0 0-.963-.49a1.24 1.24 0 1 0 0 2.483c.4 0 .738-.2.965-.492h2.512l5.23 19.8a3.282 3.282 0 0 0-.89 2.242a3.29 3.29 0 0 0 3.292 3.293a3.296 3.296 0 0 0 3.297-3.293a3.19 3.19 0 0 0-.093-.743h5.533a3.25 3.25 0 0 0-.092.743c0 1.82 1.476 3.293 3.296 3.293S28.72 29.52 28.72 27.7a3.296 3.296 0 0 0-3.294-3.297c-.95 0-1.8.41-2.402 1.053h-7.136a3.276 3.276 0 0 0-2.402-1.053c-.38 0-.738.078-1.077.196l-.182-.686H26.81a2.5 2.5 0 0 0 2.39-1.96l1.575-7.798a2.17 2.17 0 0 0 .04-.414a1.995 1.995 0 0 0-1.795-1.988zm-3.592 16.24a.298.298 0 0 1-.297-.295c.003-.166.135-.298.298-.298s.295.132.297.297a.298.298 0 0 1-.297.294zm1.78-7.495l.948-.95l-.318 1.58l-.63-.63zm-14.453-9.037L13.79 12.5l-1.29 1.29l-1.293-1.29l1.087-1.088l.46.05zm4.498.498l.538.54l-1.29 1.29l-1.293-1.29l.688-.69l1.358.15zM9.63 14.076l.87-.868l1.29 1.292l-1.29 1.29l-.565-.563l-.304-1.152zm-.295-1.12l-.328-1.24l.785.785l-.457.456zM21.79 16.5l-1.29 1.29l-1.293-1.29l1.292-1.293l1.29 1.292zm-.583-2l1.292-1.292l1.29 1.292l-1.29 1.292l-1.293-1.292zM18.5 15.79l-1.293-1.29l1.292-1.293l1.29 1.292l-1.29 1.29zm-.71.71l-1.29 1.29l-1.292-1.29l1.292-1.293l1.29 1.292zm-3.29-.71l-1.293-1.29l1.292-1.293l1.29 1.292l-1.29 1.29zm-.71.71l-1.29 1.29l-1.293-1.29l1.292-1.293l1.29 1.292zm-3.29.707l1.29 1.292l-.784.783l-.54-2.044l.033-.033zm.802 3.197l1.197-1.197l1.29 1.292l-1.29 1.29l-1.13-1.13l-.068-.256zm1.906-1.905l1.29-1.293l1.293 1.292l-1.29 1.29l-1.292-1.29zm3.292.707l1.292 1.292l-1.292 1.29l-1.292-1.29l1.292-1.293zm.708-.708l1.292-1.293l1.29 1.292l-1.29 1.29l-1.292-1.29zm3.29.707l1.293 1.292l-1.29 1.29l-1.292-1.292l1.29-1.29zm.71-.708l1.29-1.293l1.293 1.292l-1.29 1.29l-1.293-1.29zm2-2l1.29-1.293l1.293 1.292l-1.29 1.29l-1.293-1.29zm2-2l1.29-1.293L27.79 14.5l-1.29 1.292l-1.293-1.293zm-.71-.708l-1.155-1.156l2.082.23l-.926.926zM21.792 12.5l-1.29 1.292l-1.293-1.292l.29-.29l2.253.25l.04.04zm-7.29-.71l-.152-.15l.273.03l-.12.12zm-4 .002l-.65-.65l1.17.13l-.52.52zm4 9.415l1.205 1.205h-2.41l1.205-1.205zm4 0l1.205 1.206h-2.412l1.206-1.206zm4 0l1.207 1.207h-2.414l1.206-1.207zm.707-.708l1.292-1.293l1.29 1.292l-1.29 1.29l-1.293-1.29zm2-2l1.292-1.292l1.29 1.29l-1.29 1.293l-1.293-1.29zm3.292-.71l-1.292-1.29l1.29-1.292l.445.444l-.43 2.124l-.014.015zm.5-4.5l-.5.5l-.66-.657l1.017.112c.054.008.1.026.144.044zM13.488 27.993a.297.297 0 0 1 0-.593a.296.296 0 0 1 0 .591zm13.323-5.58h-1.517l1.207-1.207l.93.93c-.187.17-.423.29-.62.277z"
      />
    </svg>
  );
}

export function Times() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path
        fill="#bf8d2c"
        d="m13.06 12l4.42-4.42a.75.75 0 1 0-1.06-1.06L12 10.94L7.58 6.52a.75.75 0 0 0-1.06 1.06L10.94 12l-4.42 4.42a.75.75 0 0 0 0 1.06a.75.75 0 0 0 1.06 0L12 13.06l4.42 4.42a.75.75 0 0 0 1.06 0a.75.75 0 0 0 0-1.06Z"
      />
    </svg>
  );
}

export function View() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 32 32">
      <path
        fill="#bf8d2c"
        d="M30.94 15.66A16.69 16.69 0 0 0 16 5A16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68A16.69 16.69 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66a1 1 0 0 0 0-.68ZM16 25c-5.3 0-10.9-3.93-12.93-9C5.1 10.93 10.7 7 16 7s10.9 3.93 12.93 9C26.9 21.07 21.3 25 16 25Z"
      />
      <path
        fill="#bf8d2c"
        d="M16 10a6 6 0 1 0 6 6a6 6 0 0 0-6-6Zm0 10a4 4 0 1 1 4-4a4 4 0 0 1-4 4Z"
      />
    </svg>
  );
}

export function Unview() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 32 32">
      <path
        fill="#bf8d2c"
        d="m5.24 22.51l1.43-1.42A14.06 14.06 0 0 1 3.07 16C5.1 10.93 10.7 7 16 7a12.38 12.38 0 0 1 4 .72l1.55-1.56A14.72 14.72 0 0 0 16 5A16.69 16.69 0 0 0 1.06 15.66a1 1 0 0 0 0 .68a16 16 0 0 0 4.18 6.17Z"
      />
      <path
        fill="#bf8d2c"
        d="M12 15.73a4 4 0 0 1 3.7-3.7l1.81-1.82a6 6 0 0 0-7.33 7.33zm18.94-.07a16.4 16.4 0 0 0-5.74-7.44L30 3.41L28.59 2L2 28.59L3.41 30l5.1-5.1A15.29 15.29 0 0 0 16 27a16.69 16.69 0 0 0 14.94-10.66a1 1 0 0 0 0-.68zM20 16a4 4 0 0 1-6 3.44L19.44 14a4 4 0 0 1 .56 2zm-4 9a13.05 13.05 0 0 1-6-1.58l2.54-2.54a6 6 0 0 0 8.35-8.35l2.87-2.87A14.54 14.54 0 0 1 28.93 16C26.9 21.07 21.3 25 16 25z"
      />
    </svg>
  );
}

export function Mark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 48 48">
      <mask id="ipSCorrect0">
        <path
          fill="#fff"
          fillRule="evenodd"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="m4 24l5-5l10 10L39 9l5 5l-25 25L4 24Z"
          clipRule="evenodd"
        />
      </mask>
      <path fill="white" d="M0 0h48v48H0z" mask="url(#ipSCorrect0)" />
    </svg>
  );
}

export function CheckBoxMark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 48 48">
      <mask id="ipSCorrect0">
        <path
          fill="#fff"
          fillRule="evenodd"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="m4 24l5-5l10 10L39 9l5 5l-25 25L4 24Z"
          clipRule="evenodd"
        />
      </mask>
      <path fill="white" d="M0 0h48v48H0z" mask="url(#ipSCorrect0)" />
    </svg>
  );
}
export function Copy() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.875 11.875H0V2.1875C0 1.60734 0.230468 1.05094 0.640704 0.640704C1.05094 0.230468 1.60734 0 2.1875 0L9.6875 0C10.2677 0 10.8241 0.230468 11.2343 0.640704C11.6445 1.05094 11.875 1.60734 11.875 2.1875V11.875ZM1.875 10H10V2.1875C9.99887 2.10497 9.96558 2.02614 9.90722 1.96778C9.84886 1.90942 9.77003 1.87613 9.6875 1.875H2.1875C2.10462 1.875 2.02513 1.90792 1.96653 1.96653C1.90792 2.02513 1.875 2.10462 1.875 2.1875V10ZM13.125 3.15688V13.125H3.125V15H15V5.3125C14.9985 4.78789 14.8082 4.28135 14.4639 3.88552C14.1196 3.4897 13.6443 3.23105 13.125 3.15688Z"
        fill="#919BA4"
      />
    </svg>
  );
}

export function OpenEyeTemplate() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none">
      <g clipPath="url(#clip0_16_1351)">
        <path
          d="M0.833252 10.2446C0.833252 10.2446 4.16659 3.57796 9.99992 3.57796C15.8333 3.57796 19.1666 10.2446 19.1666 10.2446C19.1666 10.2446 15.8333 16.9113 9.99992 16.9113C4.16659 16.9113 0.833252 10.2446 0.833252 10.2446Z"
          stroke="#6A6A6A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 12.7446C11.3807 12.7446 12.5 11.6253 12.5 10.2446C12.5 8.86392 11.3807 7.74463 10 7.74463C8.61929 7.74463 7.5 8.86392 7.5 10.2446C7.5 11.6253 8.61929 12.7446 10 12.7446Z"
          stroke="#6A6A6A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16_1351">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.244629)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CloseEyeTemplate() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none">
      <g clipPath="url(#clip0_92_1904)">
        <path
          d="M15.5522 15.8942C14.1277 16.9801 12.3931 17.5816 10.6022 17.6109C4.76888 17.6109 1.43555 10.9442 1.43555 10.9442C2.47212 9.01249 3.90983 7.32475 5.65221 5.99425M8.85221 4.47758C9.42582 4.34331 10.0131 4.27619 10.6022 4.27758C16.4355 4.27758 19.7689 10.9442 19.7689 10.9442C19.263 11.8906 18.6598 12.7815 17.9689 13.6026M12.3689 12.7109C12.14 12.9565 11.864 13.1535 11.5573 13.2902C11.2507 13.4268 10.9196 13.5003 10.584 13.5062C10.2483 13.5121 9.91485 13.4504 9.60356 13.3247C9.29226 13.1989 9.00948 13.0118 8.77209 12.7744C8.53469 12.537 8.34754 12.2542 8.2218 11.9429C8.09607 11.6316 8.03432 11.2982 8.04024 10.9625C8.04616 10.6268 8.11964 10.2958 8.25628 9.98912C8.39292 9.68245 8.58992 9.40645 8.83555 9.17758"
          stroke="#6A6A6A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.43555 1.77757L19.7689 20.1109"
          stroke="#6A6A6A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_92_1904">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.602295 0.944244)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TemplateSearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none">
      <path
        d="M8.25 14.2499C11.5637 14.2499 14.25 11.5636 14.25 8.24991C14.25 4.9362 11.5637 2.24991 8.25 2.24991C4.93629 2.24991 2.25 4.9362 2.25 8.24991C2.25 11.5636 4.93629 14.2499 8.25 14.2499Z"
        stroke="#A8A4A4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 15.7499L12.4875 12.4874"
        stroke="#A8A4A4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SilverIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none">
      <circle cx="9" cy="9" r="9" fill="url(#paint0_linear_107_292)" />
      <path
        d="M7.19356 8.33249L4.06573 8.2734L8.63071 13.0845L7.19356 8.33249Z"
        fill="#AEAEAE"
      />
      <path
        d="M10.1151 8.36928L13.3192 8.36696L8.63091 13.0845L10.1151 8.36928Z"
        fill="#AEAEAE"
      />
      <path
        d="M7.19335 8.33247L5.6357 6.63202L11.8709 6.70772L10.1146 8.36926L8.68897 7.03855L7.19335 8.33247Z"
        fill="#AEAEAE"
      />
      <path
        d="M4.06554 8.27335L5.63572 6.63199L7.19337 8.33244L4.06554 8.27335Z"
        fill="#E9E8E8"
      />
      <path
        d="M13.3188 8.36695L11.87 6.70877L10.1147 8.36927L13.3188 8.36695Z"
        fill="#E9E8E8"
      />
      <path
        d="M8.63056 13.0845L7.19341 8.33249L10.1147 8.36928L8.63056 13.0845Z"
        fill="#E9E8E8"
      />
      <path
        d="M7.19332 8.33248L8.68894 7.03856L10.1146 8.36927L7.19332 8.33248Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_107_292"
          x1="4.07143"
          y1="-6.47744e-08"
          x2="15.6429"
          y2="16.5"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#E6E5E5" />
          <stop offset="1" stop-color="#BFBFBF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function TemplateCartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <g clipPath="url(#clip0_107_274)">
        <path
          d="M22.713 4.077C22.4317 3.73944 22.0796 3.46795 21.6815 3.28182C21.2835 3.09568 20.8494 2.99946 20.41 3H4.242L4.2 2.649C4.11405 1.91942 3.76338 1.24673 3.21449 0.758478C2.6656 0.270223 1.95663 0.000341793 1.222 0L1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H1.222C1.46693 2.00003 1.70334 2.08996 1.88637 2.25272C2.06941 2.41547 2.18634 2.63975 2.215 2.883L3.591 14.583C3.73385 15.7998 4.31848 16.9218 5.23391 17.736C6.14934 18.5502 7.33185 19 8.557 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8946 18.5196 20 18.2652 20 18C20 17.7348 19.8946 17.4804 19.7071 17.2929C19.5196 17.1054 19.2652 17 19 17H8.557C7.93806 16.9983 7.3348 16.8051 6.82994 16.4471C6.32507 16.089 5.94331 15.5835 5.737 15H17.657C18.8293 15.0001 19.9643 14.5882 20.8638 13.8364C21.7633 13.0846 22.37 12.0407 22.578 10.887L23.363 6.533C23.4414 6.10101 23.4237 5.65707 23.3114 5.23264C23.1991 4.80821 22.9948 4.41368 22.713 4.077ZM21.4 6.178L20.614 10.532C20.4891 11.225 20.1245 11.852 19.5839 12.3032C19.0433 12.7544 18.3612 13.0011 17.657 13H5.419L4.478 5H20.41C20.5569 4.99912 20.7022 5.03062 20.8355 5.09226C20.9689 5.15389 21.087 5.24415 21.1815 5.35661C21.276 5.46907 21.3446 5.60097 21.3824 5.74294C21.4201 5.8849 21.4262 6.03344 21.4 6.178Z"
          fill="black"
        />
        <path
          d="M7 24C8.10457 24 9 23.1046 9 22C9 20.8954 8.10457 20 7 20C5.89543 20 5 20.8954 5 22C5 23.1046 5.89543 24 7 24Z"
          fill="black"
        />
        <path
          d="M17 24C18.1046 24 19 23.1046 19 22C19 20.8954 18.1046 20 17 20C15.8954 20 15 20.8954 15 22C15 23.1046 15.8954 24 17 24Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_274">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ProfileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C10.6008 3.99974 9.22593 4.36649 8.01273 5.06363C6.79952 5.76077 5.79038 6.76392 5.08603 7.97295C4.38168 9.18199 4.00675 10.5546 3.99868 11.9538C3.9906 13.3531 4.34966 14.7299 5.04001 15.947C5.50662 15.3406 6.10644 14.8496 6.7931 14.512C7.47975 14.1744 8.23485 13.9992 9.00001 14H15C15.7652 13.9992 16.5203 14.1744 17.2069 14.512C17.8936 14.8496 18.4934 15.3406 18.96 15.947C19.6504 14.7299 20.0094 13.3531 20.0013 11.9538C19.9933 10.5546 19.6183 9.18199 18.914 7.97295C18.2096 6.76392 17.2005 5.76077 15.9873 5.06363C14.7741 4.36649 13.3993 3.99974 12 4ZM19.943 18.076C21.28 16.333 22.0032 14.1968 22 12C22 6.477 17.523 2 12 2C6.47701 2 2.00001 6.477 2.00001 12C1.99671 14.1968 2.71992 16.333 4.05701 18.076L4.05201 18.094L4.40701 18.507C5.3449 19.6035 6.5094 20.4836 7.82024 21.0866C9.13109 21.6897 10.5571 22.0013 12 22C14.0273 22.0037 16.0074 21.3879 17.675 20.235C18.3859 19.7438 19.0306 19.163 19.593 18.507L19.948 18.094L19.943 18.076ZM12 6C11.2044 6 10.4413 6.31607 9.87869 6.87868C9.31608 7.44129 9.00001 8.20435 9.00001 9C9.00001 9.79565 9.31608 10.5587 9.87869 11.1213C10.4413 11.6839 11.2044 12 12 12C12.7957 12 13.5587 11.6839 14.1213 11.1213C14.6839 10.5587 15 9.79565 15 9C15 8.20435 14.6839 7.44129 14.1213 6.87868C13.5587 6.31607 12.7957 6 12 6Z"
        fill="#0977C6"
      />
    </svg>
  );
}

export function ChevronDownTemplate() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M6.53735 9.36301L12.5374 15.363L18.5374 9.36301"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ChevronUpTemplate() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M18 15L12 9L6 15"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TemplateFB() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none">
      <g clipPath="url(#clip0_136_892)">
        <path
          d="M13.0785 16.1072H11.308V10.8522H13.1455H13.6224L13.6449 10.3758L13.7514 8.12382L13.7762 7.6002H13.252H11.308V6.45571C11.308 6.1468 11.3493 6.05784 11.3682 6.03363L11.3684 6.03334C11.3706 6.03042 11.3812 6.01646 11.4273 6.00014C11.4824 5.98062 11.5816 5.9607 11.75 5.9607C12.1237 5.9607 12.482 5.96232 12.747 5.96394C12.8794 5.96475 12.9885 5.96556 13.0644 5.96616L13.1521 5.9669L13.175 5.9671L13.1809 5.96715L13.1823 5.96717L13.1827 5.96717L13.1828 5.96717H13.1828L13.6749 5.97182L13.6873 5.47979L13.7404 3.37678L13.7517 2.92636L13.3049 2.86835L13.2405 3.36419L13.3048 2.86834L13.3047 2.86832L13.3044 2.86829L13.3037 2.8682L13.3016 2.86792L13.2944 2.86702L13.2686 2.86389C13.2464 2.86127 13.2145 2.85762 13.1736 2.8533C13.092 2.84464 12.9745 2.83326 12.8282 2.82193C12.5358 2.79928 12.1263 2.77668 11.655 2.77668C10.4233 2.77668 9.47741 3.15926 8.83961 3.80945C8.20599 4.45537 7.92651 5.31456 7.92651 6.17619V7.60019H6.77251H6.27251V8.10019V10.3522V10.8522H6.77251H7.92651V16.1072H2.9215C1.57926 16.1072 0.5 15.0279 0.5 13.6857V3.52868C0.5 2.18942 1.57447 1.11197 2.91256 1.10719H2.92149H13.0785C14.4207 1.10719 15.5 2.18646 15.5 3.5287V13.6857C15.5 15.0279 14.4207 16.1072 13.0785 16.1072Z"
          fill="black"
          stroke="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_136_892">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.607178)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TemplateInstagram() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none">
      <path
        d="M11.0001 7.84557C9.42315 7.84557 8.13624 9.08653 8.13624 10.6072C8.13624 12.1278 9.42315 13.3687 11.0001 13.3687C12.5771 13.3687 13.864 12.1278 13.864 10.6072C13.864 9.08653 12.5771 7.84557 11.0001 7.84557ZM19.5896 10.6072C19.5896 9.46358 19.6003 8.33035 19.5337 7.18884C19.4671 5.86295 19.1534 4.68622 18.148 3.71666C17.1403 2.74503 15.9222 2.44463 14.5472 2.38041C13.3612 2.31619 12.186 2.32654 11.0022 2.32654C9.81631 2.32654 8.64112 2.31619 7.45733 2.38041C6.08233 2.44463 4.86202 2.7471 3.85655 3.71666C2.84893 4.68829 2.53741 5.86295 2.47081 7.18884C2.4042 8.33242 2.41495 9.46565 2.41495 10.6072C2.41495 11.7487 2.4042 12.884 2.47081 14.0255C2.53741 15.3514 2.85108 16.5281 3.85655 17.4977C4.86416 18.4693 6.08233 18.7697 7.45733 18.8339C8.64327 18.8981 9.81846 18.8878 11.0022 18.8878C12.1882 18.8878 13.3634 18.8981 14.5472 18.8339C15.9222 18.7697 17.1425 18.4672 18.148 17.4977C19.1556 16.526 19.4671 15.3514 19.5337 14.0255C19.6024 12.884 19.5896 11.7507 19.5896 10.6072ZM11.0001 14.8562C8.56163 14.8562 6.59366 12.9585 6.59366 10.6072C6.59366 8.25577 8.56163 6.35809 11.0001 6.35809C13.4386 6.35809 15.4065 8.25577 15.4065 10.6072C15.4065 12.9585 13.4386 14.8562 11.0001 14.8562ZM15.587 7.17641C15.0177 7.17641 14.5579 6.73307 14.5579 6.18406C14.5579 5.63506 15.0177 5.19172 15.587 5.19172C16.1564 5.19172 16.6161 5.63506 16.6161 6.18406C16.6163 6.31443 16.5898 6.44354 16.5381 6.56401C16.4865 6.68448 16.4107 6.79394 16.3151 6.88612C16.2195 6.9783 16.106 7.05139 15.981 7.10121C15.8561 7.15102 15.7222 7.17658 15.587 7.17641Z"
        fill="black"
      />
    </svg>
  );
}
export function TemplateTwitter() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none">
      <path
        d="M19.7029 4.72133C19.0071 5.02966 18.2596 5.23799 17.4738 5.33216C18.2846 4.84699 18.8912 4.08338 19.1804 3.18383C18.4186 3.63632 17.5849 3.95482 16.7154 4.12549C16.1307 3.50121 15.3563 3.08743 14.5124 2.94839C13.6684 2.80935 12.8022 2.95282 12.0481 3.35654C11.2941 3.76026 10.6944 4.40163 10.3422 5.18108C9.99003 5.96053 9.90503 6.83445 10.1004 7.66716C8.55682 7.58966 7.04677 7.18845 5.66827 6.48958C4.28977 5.79071 3.07362 4.8098 2.09875 3.61049C1.76542 4.18549 1.57375 4.85216 1.57375 5.56216C1.57338 6.20132 1.73078 6.8307 2.03198 7.39444C2.33319 7.95818 2.76888 8.43886 3.30042 8.79383C2.68398 8.77421 2.08114 8.60765 1.54208 8.30799V8.35799C1.54202 9.25444 1.85211 10.1233 2.41974 10.8172C2.98736 11.511 3.77756 11.9871 4.65625 12.1647C4.0844 12.3194 3.48486 12.3422 2.90292 12.2313C3.15083 13.0027 3.63375 13.6772 4.28406 14.1604C4.93437 14.6437 5.71951 14.9115 6.52958 14.9263C5.15444 16.0058 3.45616 16.5914 1.70792 16.5888C1.39823 16.5889 1.08881 16.5708 0.78125 16.5347C2.55581 17.6756 4.62153 18.2812 6.73125 18.2788C13.8729 18.2788 17.7771 12.3638 17.7771 7.23383C17.7771 7.06716 17.7729 6.89883 17.7654 6.73216C18.5248 6.18297 19.1803 5.50291 19.7013 4.72383L19.7029 4.72133Z"
        fill="black"
      />
    </svg>
  );
}
export function TemplateLinkedIn() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.828125 2.9721C0.828125 2.56588 0.989497 2.17629 1.27674 1.88905C1.56398 1.6018 1.95357 1.44043 2.35979 1.44043H17.6281C17.8294 1.4401 18.0288 1.47948 18.2149 1.55632C18.401 1.63316 18.5701 1.74594 18.7125 1.88821C18.8549 2.03048 18.9679 2.19945 19.0449 2.38544C19.122 2.57143 19.1616 2.77079 19.1615 2.9721V18.2404C19.1617 18.4418 19.1222 18.6412 19.0453 18.8273C18.9683 19.0134 18.8555 19.1824 18.7131 19.3249C18.5708 19.4673 18.4018 19.5802 18.2157 19.6573C18.0297 19.7343 17.8303 19.7739 17.629 19.7738H2.35979C2.15858 19.7738 1.95934 19.7341 1.77346 19.6571C1.58757 19.5801 1.41868 19.4672 1.27645 19.3249C1.13421 19.1825 1.0214 19.0136 0.944477 18.8277C0.867553 18.6417 0.828016 18.4425 0.828125 18.2413V2.9721ZM8.08479 8.43043H10.5673V9.6771C10.9256 8.96043 11.8423 8.31543 13.2198 8.31543C15.8606 8.31543 16.4865 9.74293 16.4865 12.3621V17.2138H13.814V12.9588C13.814 11.4671 13.4556 10.6254 12.5456 10.6254C11.2831 10.6254 10.7581 11.5329 10.7581 12.9588V17.2138H8.08479V8.43043ZM3.50146 17.0996H6.17479V8.31543H3.50146V17.0988V17.0996ZM6.55729 5.45043C6.56233 5.67933 6.5216 5.90692 6.43749 6.11986C6.35338 6.3328 6.22758 6.52679 6.06749 6.69046C5.90739 6.85412 5.71621 6.98416 5.50517 7.07294C5.29414 7.16172 5.06749 7.20745 4.83854 7.20745C4.60959 7.20745 4.38295 7.16172 4.17191 7.07294C3.96088 6.98416 3.7697 6.85412 3.6096 6.69046C3.4495 6.52679 3.3237 6.3328 3.23959 6.11986C3.15548 5.90692 3.11475 5.67933 3.11979 5.45043C3.12969 5.00114 3.31511 4.57359 3.63636 4.25934C3.95761 3.94508 4.38915 3.76911 4.83854 3.76911C5.28794 3.76911 5.71947 3.94508 6.04072 4.25934C6.36197 4.57359 6.5474 5.00114 6.55729 5.45043Z"
        fill="black"
      />
    </svg>
  );
}
export function TemplateYouTube() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none">
      <g clipPath="url(#clip0_136_900)">
        <path
          d="M19.5838 6.02958C19.4706 5.6256 19.25 5.25987 18.9455 4.97124C18.6324 4.67375 18.2487 4.46094 17.8305 4.35291C16.2655 3.94041 9.99551 3.94041 9.99551 3.94041C7.38162 3.91067 4.76837 4.04147 2.17051 4.33208C1.75234 4.44809 1.36932 4.66565 1.05551 4.96541C0.747181 5.26208 0.523848 5.62791 0.407181 6.02874C0.126925 7.53853 -0.00924233 9.07153 0.000514319 10.6071C-0.00948568 12.1412 0.126348 13.6737 0.407181 15.1854C0.521348 15.5846 0.743848 15.9487 1.05301 16.2429C1.36218 16.5371 1.74718 16.7496 2.17051 16.8621C3.75635 17.2737 9.99551 17.2737 9.99551 17.2737C12.6127 17.3035 15.2293 17.1727 17.8305 16.8821C18.2487 16.774 18.6324 16.5612 18.9455 16.2637C19.2499 15.9752 19.4702 15.6094 19.583 15.2054C19.8706 13.6962 20.0104 12.1626 20.0005 10.6262C20.0221 9.08342 19.8825 7.54255 19.5838 6.02874V6.02958ZM8.00218 13.4604V7.75458L13.2188 10.6079L8.00218 13.4604Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_136_900">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.607178)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TemplateArrowDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <g clipPath="url(#clip0_6_868)">
        <path
          d="M12.0334 11.86C11.9715 11.7975 11.8977 11.7479 11.8165 11.7141C11.7353 11.6802 11.6481 11.6628 11.5601 11.6628C11.4721 11.6628 11.385 11.6802 11.3037 11.7141C11.2225 11.7479 11.1487 11.7975 11.0868 11.86L8.66677 14.28V0.666666C8.66677 0.489855 8.59653 0.320286 8.47151 0.195262C8.34649 0.0702379 8.17692 0 8.00011 0V0C7.8233 0 7.65373 0.0702379 7.5287 0.195262C7.40368 0.320286 7.33344 0.489855 7.33344 0.666666V14.2733L4.92011 11.86C4.86296 11.7819 4.78949 11.7171 4.7048 11.6702C4.62011 11.6234 4.52623 11.5955 4.42968 11.5886C4.33314 11.5817 4.23624 11.5959 4.14573 11.6302C4.05521 11.6645 3.97326 11.7181 3.90555 11.7872C3.83785 11.8564 3.78602 11.9395 3.75367 12.0307C3.72132 12.122 3.70922 12.2191 3.71822 12.3155C3.72722 12.4119 3.75709 12.5052 3.80577 12.5888C3.85445 12.6725 3.92077 12.7445 4.00011 12.8L6.61344 15.4133C6.98844 15.7879 7.49677 15.9982 8.02677 15.9982C8.55677 15.9982 9.0651 15.7879 9.44011 15.4133L12.0534 12.8C12.175 12.6725 12.2411 12.502 12.2374 12.3259C12.2336 12.1497 12.1603 11.9822 12.0334 11.86Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_868">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TemplateArrowUp() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <g clipPath="url(#clip0_6_871)">
        <path
          d="M4.00001 4.13998C4.12492 4.26415 4.29389 4.33385 4.47001 4.33385C4.64614 4.33385 4.81511 4.26415 4.94001 4.13998L7.33335 1.71998V15.3333C7.33335 15.5101 7.40359 15.6797 7.52861 15.8047C7.65363 15.9298 7.8232 16 8.00001 16C8.17683 16 8.34639 15.9298 8.47142 15.8047C8.59644 15.6797 8.66668 15.5101 8.66668 15.3333V1.72665L11.08 4.13998C11.142 4.20247 11.2157 4.25207 11.297 4.28591C11.3782 4.31976 11.4653 4.33718 11.5533 4.33718C11.6414 4.33718 11.7285 4.31976 11.8097 4.28591C11.891 4.25207 11.9647 4.20247 12.0267 4.13998C12.1508 4.01508 12.2205 3.84611 12.2205 3.66998C12.2205 3.49386 12.1508 3.32489 12.0267 3.19998L9.42001 0.586647C9.04501 0.212112 8.53668 0.0017395 8.00668 0.0017395C7.47668 0.0017395 6.96835 0.212112 6.59335 0.586647L4.00001 3.19998C3.87585 3.32489 3.80615 3.49386 3.80615 3.66998C3.80615 3.84611 3.87585 4.01508 4.00001 4.13998Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_871">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TemplateHamburger() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M3 12H21"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6H21"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 18H21"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none">
      <path
        d="M5.25 10.5L8.75 7L5.25 3.5"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronDownMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none">
      <path
        d="M1.5 1.25L5 4.75L8.5 1.25"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MobileProfile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <g clipPath="url(#clip0_177_1111)">
        <path
          d="M10 10C10.9889 10 11.9556 9.70676 12.7779 9.15735C13.6001 8.60794 14.241 7.82705 14.6194 6.91342C14.9978 5.99979 15.0969 4.99446 14.9039 4.02455C14.711 3.05465 14.2348 2.16373 13.5355 1.46447C12.8363 0.765206 11.9454 0.289002 10.9755 0.0960758C10.0055 -0.0968503 9.00021 0.00216643 8.08658 0.380605C7.17295 0.759043 6.39206 1.39991 5.84265 2.22215C5.29324 3.0444 5 4.0111 5 5C5.00132 6.32568 5.52853 7.59668 6.46593 8.53407C7.40332 9.47147 8.67432 9.99868 10 10ZM10 1.66667C10.6593 1.66667 11.3037 1.86217 11.8519 2.22844C12.4001 2.59471 12.8273 3.1153 13.0796 3.72439C13.3319 4.33348 13.3979 5.0037 13.2693 5.6503C13.1407 6.29691 12.8232 6.89085 12.357 7.35703C11.8908 7.8232 11.2969 8.14067 10.6503 8.26929C10.0037 8.3979 9.33348 8.33189 8.72439 8.0796C8.1153 7.82731 7.59471 7.40007 7.22843 6.8519C6.86216 6.30374 6.66667 5.65927 6.66667 5C6.66667 4.11595 7.01786 3.2681 7.64298 2.64298C8.2681 2.01786 9.11594 1.66667 10 1.66667Z"
          fill="black"
        />
        <path
          d="M10 11.6667C8.01155 11.6689 6.10518 12.4598 4.69914 13.8658C3.29309 15.2719 2.50221 17.1782 2.5 19.1667C2.5 19.3877 2.5878 19.5997 2.74408 19.7559C2.90036 19.9122 3.11232 20 3.33333 20C3.55435 20 3.76631 19.9122 3.92259 19.7559C4.07887 19.5997 4.16667 19.3877 4.16667 19.1667C4.16667 17.6196 4.78125 16.1359 5.87521 15.0419C6.96917 13.9479 8.4529 13.3334 10 13.3334C11.5471 13.3334 13.0308 13.9479 14.1248 15.0419C15.2188 16.1359 15.8333 17.6196 15.8333 19.1667C15.8333 19.3877 15.9211 19.5997 16.0774 19.7559C16.2337 19.9122 16.4457 20 16.6667 20C16.8877 20 17.0996 19.9122 17.2559 19.7559C17.4122 19.5997 17.5 19.3877 17.5 19.1667C17.4978 17.1782 16.7069 15.2719 15.3009 13.8658C13.8948 12.4598 11.9884 11.6689 10 11.6667Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_177_1111">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TemplateTimes() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M18 6L6 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Account() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.67197 3.125H6.79678C7.19132 3.125 7.50953 3.12499 7.76856 3.14267C8.03486 3.16084 8.27039 3.19915 8.49338 3.29151C9.02938 3.51353 9.45522 3.93937 9.67723 4.47537C9.76959 4.69836 9.80792 4.93389 9.8261 5.20019C9.84375 5.45922 9.84375 5.77743 9.84375 6.17197V7.29678C9.84375 7.69132 9.84375 8.00957 9.8261 8.26856C9.80792 8.53486 9.76959 8.77039 9.67723 8.99338C9.45522 9.52938 9.02938 9.95522 8.49338 10.1772C8.27039 10.2696 8.03486 10.3079 7.76856 10.3261C7.50953 10.3438 7.19132 10.3438 6.79678 10.3438H5.67197C5.27743 10.3438 4.95922 10.3438 4.70019 10.3261C4.43389 10.3079 4.19836 10.2696 3.97537 10.1772C3.43937 9.95522 3.01353 9.52938 2.79151 8.99338C2.69915 8.77039 2.66084 8.53486 2.64267 8.26856C2.62499 8.00953 2.625 7.69132 2.625 7.29678V6.17197C2.625 5.77743 2.62499 5.45922 2.64267 5.20019C2.66084 4.93389 2.69915 4.69836 2.79151 4.47537C3.01353 3.93937 3.43937 3.51353 3.97537 3.29151C4.19836 3.19915 4.43389 3.16084 4.70019 3.14267C4.95922 3.12499 5.27743 3.125 5.67197 3.125ZM4.75975 4.01563C4.53797 4.03076 4.40882 4.05907 4.31022 4.09989C3.98862 4.23311 3.73311 4.48862 3.59989 4.81022C3.55907 4.90882 3.53076 5.03797 3.51563 5.25975C3.50024 5.48547 3.50001 5.77382 3.50001 6.18749V7.28126C3.50001 7.69493 3.50024 7.98328 3.51563 8.209C3.53076 8.43078 3.55907 8.55993 3.59989 8.65853C3.73311 8.98013 3.98862 9.23564 4.31022 9.36886C4.40882 9.40968 4.53797 9.43799 4.75975 9.45312C4.98547 9.46851 5.27382 9.46874 5.68749 9.46874H6.78126C7.19493 9.46874 7.48328 9.46851 7.709 9.45312C7.93078 9.43799 8.05993 9.40968 8.15853 9.36886C8.48013 9.23564 8.73564 8.98013 8.86886 8.65853C8.90968 8.55993 8.93799 8.43078 8.95312 8.209C8.96851 7.98328 8.96874 7.69493 8.96874 7.28126V6.18749C8.96874 5.77382 8.96851 5.48547 8.95312 5.25975C8.93799 5.03797 8.90968 4.90882 8.86886 4.81022C8.73564 4.48862 8.48013 4.23311 8.15853 4.09989C8.05993 4.05907 7.93078 4.03076 7.709 4.01563C7.48328 4.00024 7.19493 4.00001 6.78126 4.00001H5.68749C5.27382 4.00001 4.98547 4.00024 4.75975 4.01563ZM5.67197 11.6562H6.79678C7.19132 11.6562 7.50953 11.6562 7.76856 11.6739C8.03486 11.6921 8.27039 11.7304 8.49338 11.8228C9.02938 12.0448 9.45522 12.4706 9.67723 13.0066C9.76959 13.2296 9.80792 13.4651 9.8261 13.7314C9.84375 13.9905 9.84375 14.3087 9.84375 14.7032V15.828C9.84375 16.2226 9.84375 16.5408 9.8261 16.7998C9.80792 17.0661 9.76959 17.3016 9.67723 17.5246C9.45522 18.0606 9.02938 18.4865 8.49338 18.7085C8.27039 18.8008 8.03486 18.8392 7.76856 18.8573C7.50953 18.875 7.19132 18.875 6.79678 18.875H5.67197C5.27743 18.875 4.95922 18.875 4.70019 18.8573C4.43389 18.8392 4.19836 18.8008 3.97537 18.7085C3.43937 18.4865 3.01353 18.0606 2.79151 17.5246C2.69915 17.3016 2.66084 17.0661 2.64267 16.7998C2.62499 16.5408 2.625 16.2226 2.625 15.828V14.7032C2.625 14.3087 2.62499 13.9905 2.64267 13.7314C2.66084 13.4651 2.69915 13.2296 2.79151 13.0066C3.01353 12.4706 3.43937 12.0448 3.97537 11.8228C4.19836 11.7304 4.43389 11.6921 4.70019 11.6739C4.95922 11.6562 5.27743 11.6562 5.67197 11.6562ZM4.75975 12.5469C4.53797 12.562 4.40882 12.5903 4.31022 12.6311C3.98862 12.7644 3.73311 13.0199 3.59989 13.3415C3.55907 13.4401 3.53076 13.5692 3.51563 13.791C3.50024 14.0167 3.50001 14.3051 3.50001 14.7187V15.8125C3.50001 16.2262 3.50024 16.5145 3.51563 16.7403C3.53076 16.962 3.55907 17.0912 3.59989 17.1898C3.73311 17.5114 3.98862 17.7669 4.31022 17.9001C4.40882 17.9409 4.53797 17.9692 4.75975 17.9844C4.98547 17.9998 5.27382 18 5.68749 18H6.78126C7.19493 18 7.48328 17.9998 7.709 17.9844C7.93078 17.9692 8.05993 17.9409 8.15853 17.9001C8.48013 17.7669 8.73564 17.5114 8.86886 17.1898C8.90968 17.0912 8.93799 16.962 8.95312 16.7403C8.96851 16.5145 8.96874 16.2262 8.96874 15.8125V14.7187C8.96874 14.3051 8.96851 14.0167 8.95312 13.791C8.93799 13.5692 8.90968 13.4401 8.86886 13.3415C8.73564 13.0199 8.48013 12.7644 8.15853 12.6311C8.05993 12.5903 7.93078 12.562 7.709 12.5469C7.48328 12.5315 7.19493 12.5313 6.78126 12.5313H5.68749C5.27382 12.5313 4.98547 12.5315 4.75975 12.5469ZM14.2032 3.125H15.328C15.7226 3.125 16.0408 3.12499 16.2998 3.14267C16.5661 3.16084 16.8016 3.19915 17.0246 3.29151C17.5606 3.51353 17.9865 3.93937 18.2085 4.47537C18.3008 4.69836 18.3392 4.93389 18.3573 5.20019C18.375 5.45922 18.375 5.77743 18.375 6.17197V7.29678C18.375 7.69132 18.375 8.00957 18.3573 8.26856C18.3392 8.53486 18.3008 8.77039 18.2085 8.99338C17.9865 9.52938 17.5606 9.95522 17.0246 10.1772C16.8016 10.2696 16.5661 10.3079 16.2998 10.3261C16.0408 10.3438 15.7226 10.3438 15.328 10.3438H14.2032C13.8087 10.3438 13.4905 10.3438 13.2314 10.3261C12.9651 10.3079 12.7296 10.2696 12.5066 10.1772C11.9706 9.95522 11.5448 9.52938 11.3228 8.99338C11.2304 8.77039 11.1921 8.53486 11.1739 8.26856C11.1562 8.00953 11.1562 7.69132 11.1562 7.29678V6.17197C11.1562 5.77743 11.1562 5.45922 11.1739 5.20019C11.1921 4.93389 11.2304 4.69836 11.3228 4.47537C11.5448 3.93937 11.9706 3.51353 12.5066 3.29151C12.7296 3.19915 12.9651 3.16084 13.2314 3.14267C13.4905 3.12499 13.8087 3.125 14.2032 3.125ZM13.291 4.01563C13.0692 4.03076 12.9401 4.05907 12.8415 4.09989C12.5199 4.23311 12.2644 4.48862 12.1311 4.81022C12.0903 4.90882 12.062 5.03797 12.0469 5.25975C12.0315 5.48547 12.0313 5.77382 12.0313 6.18749V7.28126C12.0313 7.69493 12.0315 7.98328 12.0469 8.209C12.062 8.43078 12.0903 8.55993 12.1311 8.65853C12.2644 8.98013 12.5199 9.23564 12.8415 9.36886C12.9401 9.40968 13.0692 9.43799 13.291 9.45312C13.5167 9.46851 13.8051 9.46874 14.2187 9.46874H15.3125C15.7262 9.46874 16.0145 9.46851 16.2403 9.45312C16.462 9.43799 16.5912 9.40968 16.6898 9.36886C17.0114 9.23564 17.2669 8.98013 17.4001 8.65853C17.4409 8.55993 17.4692 8.43078 17.4844 8.209C17.4998 7.98328 17.5 7.69493 17.5 7.28126V6.18749C17.5 5.77382 17.4998 5.48547 17.4844 5.25975C17.4692 5.03797 17.4409 4.90882 17.4001 4.81022C17.2669 4.48862 17.0114 4.23311 16.6898 4.09989C16.5912 4.05907 16.462 4.03076 16.2403 4.01563C16.0145 4.00024 15.7262 4.00001 15.3125 4.00001H14.2187C13.8051 4.00001 13.5167 4.00024 13.291 4.01563ZM14.2032 11.6562H15.328C15.7226 11.6562 16.0408 11.6562 16.2998 11.6739C16.5661 11.6921 16.8016 11.7304 17.0246 11.8228C17.5606 12.0448 17.9865 12.4706 18.2085 13.0066C18.3008 13.2296 18.3392 13.4651 18.3573 13.7314C18.375 13.9905 18.375 14.3087 18.375 14.7032V15.828C18.375 16.2226 18.375 16.5408 18.3573 16.7998C18.3392 17.0661 18.3008 17.3016 18.2085 17.5246C17.9865 18.0606 17.5606 18.4865 17.0246 18.7085C16.8016 18.8008 16.5661 18.8392 16.2998 18.8573C16.0408 18.875 15.7226 18.875 15.328 18.875H14.2032C13.8087 18.875 13.4905 18.875 13.2314 18.8573C12.9651 18.8392 12.7296 18.8008 12.5066 18.7085C11.9706 18.4865 11.5448 18.0606 11.3228 17.5246C11.2304 17.3016 11.1921 17.0661 11.1739 16.7998C11.1562 16.5408 11.1562 16.2226 11.1562 15.828V14.7032C11.1562 14.3087 11.1562 13.9905 11.1739 13.7314C11.1921 13.4651 11.2304 13.2296 11.3228 13.0066C11.5448 12.4706 11.9706 12.0448 12.5066 11.8228C12.7296 11.7304 12.9651 11.6921 13.2314 11.6739C13.4905 11.6562 13.8087 11.6562 14.2032 11.6562ZM13.291 12.5469C13.0692 12.562 12.9401 12.5903 12.8415 12.6311C12.5199 12.7644 12.2644 13.0199 12.1311 13.3415C12.0903 13.4401 12.062 13.5692 12.0469 13.791C12.0315 14.0167 12.0313 14.3051 12.0313 14.7187V15.8125C12.0313 16.2262 12.0315 16.5145 12.0469 16.7403C12.062 16.962 12.0903 17.0912 12.1311 17.1898C12.2644 17.5114 12.5199 17.7669 12.8415 17.9001C12.9401 17.9409 13.0692 17.9692 13.291 17.9844C13.5167 17.9998 13.8051 18 14.2187 18H15.3125C15.7262 18 16.0145 17.9998 16.2403 17.9844C16.462 17.9692 16.5912 17.9409 16.6898 17.9001C17.0114 17.7669 17.2669 17.5114 17.4001 17.1898C17.4409 17.0912 17.4692 16.962 17.4844 16.7403C17.4998 16.5145 17.5 16.2262 17.5 15.8125V14.7187C17.5 14.3051 17.4998 14.0167 17.4844 13.791C17.4692 13.5692 17.4409 13.4401 17.4001 13.3415C17.2669 13.0199 17.0114 12.7644 16.6898 12.6311C16.5912 12.5903 16.462 12.562 16.2403 12.5469C16.0145 12.5315 15.7262 12.5313 15.3125 12.5313H14.2187C13.8051 12.5313 13.5167 12.5315 13.291 12.5469Z"
        fill="#222222"
        stroke="black"
        strokeWidth="0.1"
      />
    </svg>
  );
}

export function Tier() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="26"
      viewBox="0 0 22 26"
      fill="none">
      <path
        d="M2 20V16.6C2 16.0477 2.44772 15.6 3 15.6H5.57143C6.12371 15.6 6.57143 15.1523 6.57143 14.6V11.8C6.57143 11.2477 7.01914 10.8 7.57143 10.8H11.6667C12.219 10.8 12.6667 10.3523 12.6667 9.8V7C12.6667 6.44772 13.1144 6 13.6667 6H17C17.5523 6 18 6.44772 18 7V20C18 20.5523 17.5523 21 17 21H3C2.44772 21 2 20.5523 2 20Z"
        stroke="black"
        strokeWidth="1.2"
      />
    </svg>
  );
}

export function Statement() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none">
      <path
        d="M17.3022 1H2.8246C2.52924 1 2.24597 1.11238 2.03712 1.31242C1.82827 1.51246 1.71094 1.78377 1.71094 2.06667V15.9333C1.71094 16.2162 1.82827 16.4875 2.03712 16.6876C2.24597 16.8876 2.52924 17 2.8246 17H17.3022C17.5976 17 17.8809 16.8876 18.0897 16.6876C18.2986 16.4875 18.4159 16.2162 18.4159 15.9333V2.06667C18.4159 1.78377 18.2986 1.51246 18.0897 1.31242C17.8809 1.11238 17.5976 1 17.3022 1ZM17.3022 15.9333H2.8246V2.06667H17.3022V15.9333ZM5.60876 9.53333H14.5181C14.6658 9.53333 14.8074 9.47714 14.9118 9.37712C15.0162 9.2771 15.0749 9.14145 15.0749 9C15.0749 8.85855 15.0162 8.7229 14.9118 8.62288C14.8074 8.52286 14.6658 8.46667 14.5181 8.46667H5.60876C5.46108 8.46667 5.31945 8.52286 5.21502 8.62288C5.1106 8.7229 5.05193 8.85855 5.05193 9C5.05193 9.14145 5.1106 9.2771 5.21502 9.37712C5.31945 9.47714 5.46108 9.53333 5.60876 9.53333ZM5.60876 6.33333H14.5181C14.6658 6.33333 14.8074 6.27714 14.9118 6.17712C15.0162 6.0771 15.0749 5.94145 15.0749 5.8C15.0749 5.65855 15.0162 5.5229 14.9118 5.42288C14.8074 5.32286 14.6658 5.26667 14.5181 5.26667H5.60876C5.46108 5.26667 5.31945 5.32286 5.21502 5.42288C5.1106 5.5229 5.05193 5.65855 5.05193 5.8C5.05193 5.94145 5.1106 6.0771 5.21502 6.17712C5.31945 6.27714 5.46108 6.33333 5.60876 6.33333ZM5.60876 12.7333H14.5181C14.6658 12.7333 14.8074 12.6771 14.9118 12.5771C15.0162 12.4771 15.0749 12.3414 15.0749 12.2C15.0749 12.0586 15.0162 11.9229 14.9118 11.8229C14.8074 11.7229 14.6658 11.6667 14.5181 11.6667H5.60876C5.46108 11.6667 5.31945 11.7229 5.21502 11.8229C5.1106 11.9229 5.05193 12.0586 5.05193 12.2C5.05193 12.3414 5.1106 12.4771 5.21502 12.5771C5.31945 12.6771 5.46108 12.7333 5.60876 12.7333Z"
        fill="black"
      />
    </svg>
  );
}

export function Order() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M16.2162 1.83008H3.96007C3.29541 1.83086 2.65819 2.11262 2.18821 2.61352C1.71822 3.11442 1.45386 3.79357 1.45312 4.50195V16.0455C1.45312 17.5186 2.57791 18.7173 3.96007 18.7173H16.2162C17.5984 18.7173 18.7232 17.5186 18.7232 16.0455V4.50195C18.7232 3.02886 17.5984 1.83008 16.2162 1.83008ZM8.06032 3.08355H12.116V8.8897L10.0882 8.04136L8.06032 8.88911V3.08355ZM17.4184 16.0455C17.4184 16.5365 16.677 17.3336 16.2162 17.3336H3.96007C3.49935 17.3336 2.64062 16.5365 2.64062 16.0455V4.50195C2.64062 4.01092 3.49935 3.08355 3.96007 3.08355L6.76321 3.08338V9.44036C6.76313 9.58774 6.79736 9.73284 6.86285 9.86265C6.92833 9.99246 7.02302 10.1029 7.13841 10.1841C7.25381 10.2653 7.38631 10.3147 7.52404 10.3279C7.66177 10.3411 7.80041 10.3177 7.92755 10.2597L10.0882 9.24046L12.265 10.2591C12.392 10.3174 12.5307 10.341 12.6684 10.3279C12.8061 10.3147 12.9386 10.2652 13.0539 10.1837C13.1693 10.1026 13.264 9.99221 13.3295 9.86248C13.395 9.73274 13.4294 9.5877 13.4294 9.44036L13.4833 3.08347L16.2162 3.08355C16.677 3.08355 17.4184 4.01092 17.4184 4.50195V16.0455Z"
        fill="black"
      />
    </svg>
  );
}

export function Auction() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none">
      <path
        d="M4 0.75H15C16.7949 0.75 18.25 2.20507 18.25 4V10C18.25 11.7949 16.7949 13.25 15 13.25H9H4C2.20507 13.25 0.75 11.7949 0.75 10V4C0.75 2.20507 2.20507 0.75 4 0.75Z"
        stroke="black"
        stroke-width="1.5"
      />
    </svg>
  );
}

export function Transfer() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none">
      <g clipPath="url(#clip0_1_263)">
        <path
          d="M16.826 1.59619L15.3332 3.08025M9.65312 8.72708L12.7208 5.67734M12.7208 5.67734L14.96 7.90343L17.5723 5.30633L15.3332 3.08025M12.7208 5.67734L15.3332 3.08025M9.65312 8.72708C10.0385 9.10512 10.3449 9.55521 10.5546 10.0514C10.7643 10.5477 10.8732 11.0802 10.875 11.6185C10.8768 12.1567 10.7715 12.69 10.5651 13.1876C10.3588 13.6852 10.0555 14.1374 9.67263 14.518C9.2898 14.8986 8.83502 15.2001 8.33447 15.4053C7.83392 15.6104 7.2975 15.7151 6.7561 15.7133C6.21469 15.7115 5.67899 15.6032 5.17983 15.3948C4.68068 15.1863 4.22794 14.8817 3.84768 14.4986C3.09989 13.7289 2.68611 12.6979 2.69547 11.6279C2.70482 10.5578 3.13656 9.53421 3.89769 8.77753C4.65882 8.02085 5.68844 7.59164 6.7648 7.58235C7.84116 7.57305 8.87813 7.9844 9.65237 8.72782L9.65312 8.72708Z"
          stroke="black"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_263">
          <rect
            width="19"
            height="17"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Address() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M7.63362 17.3093V14.7537C7.6336 14.1037 8.16354 13.5755 8.82011 13.5712H11.2252C11.8849 13.5712 12.4197 14.1006 12.4197 14.7537V17.3173C12.4195 17.8692 12.8645 18.3202 13.4218 18.3332H15.0252C16.6235 18.3332 17.9193 17.0504 17.9193 15.468V8.19803C17.9107 7.57553 17.6155 6.99096 17.1176 6.6107L11.634 2.23759C10.6734 1.47614 9.30777 1.47614 8.34712 2.23759L2.88763 6.61863C2.38782 6.99736 2.09209 7.58289 2.08594 8.20597V15.468C2.08594 17.0504 3.38167 18.3332 4.98003 18.3332H6.58341C7.15457 18.3332 7.61758 17.8748 7.61758 17.3093"
        stroke="#200E32"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Pin() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="14"
      viewBox="0 0 24 14"
      fill="none">
      <path
        d="M13.8181 7.17877C13.8181 7.57877 13.4945 7.90596 13.0909 7.90596H12.3637V8.63315C12.3637 9.03316 12.0401 9.36034 11.6366 9.36034C11.233 9.36034 10.9094 9.03314 10.9094 8.63315V7.90596H10.1822C9.77862 7.90596 9.45498 7.57876 9.45498 7.17877C9.45498 6.77879 9.77864 6.45158 10.1822 6.45158H10.9094V5.72439C10.9094 5.32438 11.233 4.9972 11.6366 4.9972C12.0401 4.9972 12.3637 5.3244 12.3637 5.72439V6.45158H13.0909C13.4945 6.45158 13.8181 6.77879 13.8181 7.17877ZM6.54557 6.45158H5.81837V5.72439C5.81837 5.32438 5.49472 4.9972 5.09118 4.9972C4.68765 4.9972 4.36399 5.3244 4.36399 5.72439V6.45158H3.6368C3.23325 6.45158 2.90961 6.77879 2.90961 7.17877C2.90961 7.57876 3.23326 7.90596 3.6368 7.90596H4.36399V8.63315C4.36399 9.03316 4.68765 9.36034 5.09118 9.36034C5.49472 9.36034 5.81837 9.03314 5.81837 8.63315V7.90596H6.54557C6.94912 7.90596 7.27276 7.57876 7.27276 7.17877C7.27276 6.77879 6.9491 6.45158 6.54557 6.45158ZM19.6362 6.45158H18.909V5.72439C18.909 5.32438 18.5853 4.9972 18.1818 4.9972C17.7782 4.9972 17.4546 5.3244 17.4546 5.72439V6.45158H16.7274C16.3239 6.45158 16.0002 6.77879 16.0002 7.17877C16.0002 7.57876 16.3239 7.90596 16.7274 7.90596H17.4546V8.63315C17.4546 9.03316 17.7783 9.36034 18.1818 9.36034C18.5853 9.36034 18.909 9.03314 18.909 8.63315V7.90596H19.6362C20.0397 7.90596 20.3634 7.57876 20.3634 7.17877C20.3634 6.77879 20.0397 6.45158 19.6362 6.45158ZM23.2722 2.91212L23.2725 11.0879C23.2725 12.2914 22.2944 13.2698 21.0906 13.2698L2.1819 13.2695C0.978354 13.2695 0 12.2915 0 11.0876V2.91212C0 1.70858 0.978029 0.730225 2.1819 0.730225H21.0906C22.2941 0.730478 23.2722 1.70851 23.2722 2.91212ZM22.0103 2.91212C22.0103 2.51211 21.4905 1.95375 21.0906 1.95375H2.1819C1.44213 1.95375 1.13175 2.51188 1.13175 2.91186L1.132 11.0876C1.132 11.4876 1.33774 12.2005 2.1819 12.2005H21.0906C21.7512 12.2005 22.0105 11.4878 22.0105 11.0879L22.0103 2.91212Z"
        fill="black"
      />
    </svg>
  );
}

export function ArrowRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M15 18L9 12L15 6"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CameraIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M15.0003 9.16667C15.0003 8.3675 14.4337 7.69917 13.6828 7.53833C13.9828 7.0375 14.167 6.45833 14.167 5.83333C14.167 3.995 12.672 2.5 10.8337 2.5C9.56949 2.5 8.48283 3.21417 7.91699 4.25333C7.35116 3.21417 6.26449 2.5 5.00033 2.5C3.16199 2.5 1.66699 3.995 1.66699 5.83333C1.66699 6.585 1.92699 7.2725 2.34783 7.83C2.13748 7.98381 1.96626 8.18494 1.84799 8.41713C1.72972 8.64933 1.66772 8.90609 1.66699 9.16667V15.8333C1.66699 16.7525 2.41449 17.5 3.33366 17.5H13.3337C14.2528 17.5 15.0003 16.7525 15.0003 15.8333V13.635L18.3337 15.3017V9.46833L15.0003 11.135V9.16667ZM10.8337 4.16667C11.7528 4.16667 12.5003 4.91417 12.5003 5.83333C12.5003 6.7525 11.7528 7.5 10.8337 7.5C9.91449 7.5 9.16699 6.7525 9.16699 5.83333C9.16699 4.91417 9.91449 4.16667 10.8337 4.16667ZM5.00033 4.16667C5.91949 4.16667 6.66699 4.91417 6.66699 5.83333C6.66699 6.7525 5.91949 7.5 5.00033 7.5C4.08116 7.5 3.33366 6.7525 3.33366 5.83333C3.33366 4.91417 4.08116 4.16667 5.00033 4.16667ZM3.33366 15.8333V9.16667H13.3337L13.3353 15.8333H3.33366Z"
        fill="white"
      />
    </svg>
  );
}

export function TemplateCalendar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <g clipPath="url(#clip0_6_3968)">
        <path
          d="M13.3359 1.99984H12.6693V0.666504H11.3359V1.99984H4.66927V0.666504H3.33594V1.99984H2.66927C1.93594 1.99984 1.33594 2.59984 1.33594 3.33317V13.9998C1.33594 14.7332 1.93594 15.3332 2.66927 15.3332H13.3359C14.0693 15.3332 14.6693 14.7332 14.6693 13.9998V3.33317C14.6693 2.59984 14.0693 1.99984 13.3359 1.99984ZM13.3359 13.9998H2.66927V5.33317H13.3359V13.9998Z"
          fill="#0072C3"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_3968">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SMCart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none">
      <g clipPath="url(#clip0_70_1388)">
        <path
          d="M11.0423 2.34132C10.9151 2.18877 10.756 2.06607 10.5761 1.98195C10.3962 1.89783 10.2 1.85434 10.0014 1.85458H2.69447L2.67549 1.69595C2.63665 1.36623 2.47817 1.06221 2.2301 0.841551C1.98203 0.620889 1.66162 0.498919 1.32961 0.498764L1.22928 0.498764C1.10942 0.498764 0.994469 0.546379 0.909714 0.631134C0.824959 0.71589 0.777344 0.830842 0.777344 0.950704C0.777344 1.07057 0.824959 1.18552 0.909714 1.27027C0.994469 1.35503 1.10942 1.40264 1.22928 1.40264H1.32961C1.44031 1.40266 1.54715 1.4433 1.62987 1.51686C1.71259 1.59041 1.76544 1.69177 1.77839 1.80171L2.40026 7.08941C2.46482 7.63933 2.72904 8.1464 3.14276 8.51438C3.55648 8.88236 4.0909 9.08564 4.6446 9.08563H9.36421C9.48407 9.08563 9.59902 9.03802 9.68378 8.95326C9.76853 8.8685 9.81615 8.75355 9.81615 8.63369C9.81615 8.51383 9.76853 8.39887 9.68378 8.31412C9.59902 8.22936 9.48407 8.18175 9.36421 8.18175H4.6446C4.36487 8.18096 4.09224 8.09368 3.86407 7.93185C3.6359 7.77003 3.46337 7.5416 3.37013 7.27787H8.75725C9.28706 7.2779 9.80003 7.09177 10.2065 6.75201C10.6131 6.41224 10.8873 5.94044 10.9813 5.41904L11.336 3.45129C11.3714 3.25605 11.3635 3.05542 11.3127 2.8636C11.2619 2.67179 11.1696 2.49348 11.0423 2.34132ZM10.4489 3.29085L10.0936 5.2586C10.0372 5.57179 9.8724 5.85516 9.62808 6.05907C9.38376 6.26299 9.07549 6.37447 8.75725 6.37399H3.22641L2.80113 2.75847H10.0014C10.0678 2.75807 10.1335 2.7723 10.1938 2.80016C10.254 2.82801 10.3074 2.86881 10.3501 2.91963C10.3928 2.97046 10.4238 3.03007 10.4409 3.09423C10.458 3.15839 10.4607 3.22552 10.4489 3.29085Z"
          fill="black"
        />
        <path
          d="M3.94099 11.3456C4.44019 11.3456 4.84487 10.9409 4.84487 10.4417C4.84487 9.94254 4.44019 9.53786 3.94099 9.53786C3.44179 9.53786 3.03711 9.94254 3.03711 10.4417C3.03711 10.9409 3.44179 11.3456 3.94099 11.3456Z"
          fill="black"
        />
        <path
          d="M8.46052 11.3456C8.95972 11.3456 9.3644 10.9409 9.3644 10.4417C9.3644 9.94254 8.95972 9.53786 8.46052 9.53786C7.96132 9.53786 7.55664 9.94254 7.55664 10.4417C7.55664 10.9409 7.96132 11.3456 8.46052 11.3456Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_70_1388">
          <rect
            width="10.8466"
            height="10.8466"
            fill="white"
            transform="translate(0.777344 0.498764)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BottomNavHome({homePage}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M2.5 7.50002L10 1.66669L17.5 7.50002V16.6667C17.5 17.1087 17.3244 17.5326 17.0118 17.8452C16.6993 18.1578 16.2754 18.3334 15.8333 18.3334H4.16667C3.72464 18.3334 3.30072 18.1578 2.98816 17.8452C2.67559 17.5326 2.5 17.1087 2.5 16.6667V7.50002Z"
        stroke={homePage ? '#F0BD2D' : '#000'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 18.3333V10H12.5V18.3333"
        stroke={homePage ? '#F0BD2D' : '#000'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BottomNavCart({cartPage}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <g clipPath="url(#clip0_70_1365)">
        <path
          d="M7.49935 18.3334C7.95959 18.3334 8.33268 17.9603 8.33268 17.5C8.33268 17.0398 7.95959 16.6667 7.49935 16.6667C7.03911 16.6667 6.66602 17.0398 6.66602 17.5C6.66602 17.9603 7.03911 18.3334 7.49935 18.3334Z"
          stroke={cartPage ? '#F0BD2D' : '#000'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6673 18.3334C17.1276 18.3334 17.5007 17.9603 17.5007 17.5C17.5007 17.0398 17.1276 16.6667 16.6673 16.6667C16.2071 16.6667 15.834 17.0398 15.834 17.5C15.834 17.9603 16.2071 18.3334 16.6673 18.3334Z"
          stroke={cartPage ? '#F0BD2D' : '#000'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.833984 0.833313H4.16732L6.40065 11.9916C6.47686 12.3753 6.68557 12.7199 6.99027 12.9652C7.29497 13.2105 7.67623 13.3408 8.06732 13.3333H16.1673C16.5584 13.3408 16.9397 13.2105 17.2444 12.9652C17.5491 12.7199 17.7578 12.3753 17.834 11.9916L19.1673 4.99998H5.00065"
          stroke={cartPage ? '#F0BD2D' : '#000'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_70_1365">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BottomNavProfile({profilePage}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M16.6673 17.5V15.8333C16.6673 14.9493 16.3161 14.1014 15.691 13.4763C15.0659 12.8512 14.218 12.5 13.334 12.5H6.66732C5.78326 12.5 4.93542 12.8512 4.31029 13.4763C3.68517 14.1014 3.33398 14.9493 3.33398 15.8333V17.5"
        stroke={profilePage ? '#F0BD2D' : '#000'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99935 9.16667C11.8403 9.16667 13.3327 7.67428 13.3327 5.83333C13.3327 3.99238 11.8403 2.5 9.99935 2.5C8.1584 2.5 6.66602 3.99238 6.66602 5.83333C6.66602 7.67428 8.1584 9.16667 9.99935 9.16667Z"
        stroke={profilePage ? '#F0BD2D' : '#000'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ProfileTier() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none">
      <g clipPath="url(#clip0_72_1765)">
        <path
          d="M24.3896 18.9999L16.2438 2.36967C15.9009 1.6694 15.3684 1.07939 14.7069 0.666711C14.0453 0.254035 13.2813 0.0352592 12.5016 0.0352592C11.7219 0.0352592 10.9578 0.254035 10.2963 0.666711C9.63473 1.07939 9.10225 1.6694 8.75939 2.36967L0.61251 18.9999C0.301256 19.6351 0.156856 20.3392 0.192918 21.0456C0.22898 21.7521 0.444316 22.4378 0.818636 23.038C1.19296 23.6383 1.71393 24.1333 2.33248 24.4766C2.95103 24.8198 3.64678 24.9999 4.35418 24.9999H20.6469C21.3544 25.0001 22.0502 24.8201 22.6689 24.4769C23.2876 24.1338 23.8088 23.6387 24.1832 23.0385C24.5576 22.4382 24.7731 21.7525 24.8092 21.0459C24.8453 20.3393 24.7009 19.6352 24.3896 18.9999ZM20.4177 15.6249H4.58438L7.13647 10.4165H17.8656L20.4177 15.6249ZM10.6261 3.28634C10.7975 2.93634 11.0638 2.64147 11.3945 2.43523C11.7252 2.229 12.1071 2.11967 12.4969 2.11967C12.8866 2.11967 13.2686 2.229 13.5993 2.43523C13.93 2.64147 14.1962 2.93634 14.3677 3.28634L16.8438 8.33322H8.1573L10.6261 3.28634ZM22.4115 21.9322C22.2268 22.2353 21.9664 22.4852 21.6559 22.6572C21.3455 22.8292 20.9956 22.9175 20.6406 22.9134H4.35418C4.00013 22.9141 3.65173 22.8246 3.34189 22.6533C3.03205 22.482 2.77099 22.2345 2.58334 21.9343C2.39569 21.634 2.28766 21.2909 2.26943 20.9373C2.25121 20.5838 2.32339 20.2314 2.47918 19.9134L3.56459 17.7082H21.4365L22.5177 19.9166C22.6773 20.233 22.7518 20.5855 22.7339 20.9394C22.716 21.2934 22.6063 21.6366 22.4156 21.9353L22.4115 21.9322Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_72_1765">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ProfileStatement() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none">
      <g clipPath="url(#clip0_72_1768)">
        <path
          d="M16.6667 -1.52588e-05H8.33333C6.95251 0.00163876 5.62871 0.550903 4.65231 1.5273C3.67592 2.50369 3.12665 3.82749 3.125 5.20832V23.9583C3.12515 24.1478 3.17697 24.3336 3.27488 24.4958C3.37279 24.658 3.51308 24.7905 3.68066 24.8789C3.84824 24.9673 4.03676 25.0083 4.22592 24.9975C4.41507 24.9867 4.59771 24.9246 4.75417 24.8177L6.94792 23.3187L9.14167 24.8177C9.31499 24.9364 9.52014 24.9999 9.73021 24.9999C9.94027 24.9999 10.1454 24.9364 10.3187 24.8177L12.5062 23.3187L14.6937 24.8177C14.8672 24.9366 15.0725 25.0002 15.2828 25.0002C15.4931 25.0002 15.6984 24.9366 15.8719 24.8177L18.0594 23.3198L20.2469 24.8167C20.4032 24.9232 20.5857 24.9851 20.7746 24.9958C20.9635 25.0064 21.1517 24.9655 21.3191 24.8772C21.4865 24.789 21.6267 24.6568 21.7246 24.4949C21.8225 24.333 21.8745 24.1475 21.875 23.9583V5.20832C21.8733 3.82749 21.3241 2.50369 20.3477 1.5273C19.3713 0.550903 18.0475 0.00163876 16.6667 -1.52588e-05V-1.52588e-05ZM19.7917 21.9792L18.6458 21.1958C18.4723 21.0767 18.2667 21.0129 18.0562 21.0129C17.8458 21.0129 17.6402 21.0767 17.4667 21.1958L15.2792 22.6948L13.0917 21.1958C12.9182 21.0769 12.7129 21.0133 12.5026 21.0133C12.2923 21.0133 12.087 21.0769 11.9135 21.1958L9.72604 22.6948L7.53854 21.1958C7.36533 21.0774 7.16037 21.014 6.95052 21.014C6.74067 21.014 6.53572 21.0774 6.3625 21.1958L5.20833 21.9792V5.20832C5.20833 4.37952 5.53757 3.58466 6.12362 2.99861C6.70968 2.41256 7.50453 2.08332 8.33333 2.08332H16.6667C17.4955 2.08332 18.2903 2.41256 18.8764 2.99861C19.4624 3.58466 19.7917 4.37952 19.7917 5.20832V21.9792Z"
          fill="black"
        />
        <path
          d="M16.666 8.33397H8.33268C7.75739 8.33397 7.29102 8.80034 7.29102 9.37563C7.29102 9.95093 7.75739 10.4173 8.33268 10.4173H16.666C17.2413 10.4173 17.7077 9.95093 17.7077 9.37563C17.7077 8.80034 17.2413 8.33397 16.666 8.33397Z"
          fill="black"
        />
        <path
          d="M14.5827 12.5H8.33268C7.75738 12.5 7.29102 12.9664 7.29102 13.5417C7.29102 14.117 7.75738 14.5833 8.33268 14.5833H14.5827C15.158 14.5833 15.6243 14.117 15.6243 13.5417C15.6243 12.9664 15.158 12.5 14.5827 12.5Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_72_1768">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ProfileOrder() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none">
      <g clipPath="url(#clip0_72_1771)">
        <path
          d="M12.5 0C10.0277 0 7.61099 0.733112 5.55538 2.10663C3.49976 3.48015 1.89761 5.43238 0.951511 7.71646C0.00541608 10.0005 -0.242126 12.5139 0.24019 14.9386C0.722505 17.3634 1.91301 19.5907 3.66117 21.3388C5.40933 23.087 7.63661 24.2775 10.0614 24.7598C12.4861 25.2421 14.9995 24.9946 17.2835 24.0485C19.5676 23.1024 21.5199 21.5002 22.8934 19.4446C24.2669 17.389 25 14.9723 25 12.5C24.9964 9.18589 23.6783 6.00855 21.3349 3.66512C18.9915 1.3217 15.8141 0.00358446 12.5 0V0ZM12.5 22.9167C10.4398 22.9167 8.42583 22.3057 6.71282 21.1611C4.9998 20.0165 3.66467 18.3897 2.87626 16.4863C2.08785 14.5829 1.88156 12.4884 2.28349 10.4678C2.68542 8.44718 3.67751 6.5911 5.13431 5.1343C6.59111 3.67751 8.44718 2.68542 10.4678 2.28349C12.4885 1.88156 14.5829 2.08784 16.4863 2.87626C18.3897 3.66467 20.0165 4.9998 21.1611 6.71281C22.3057 8.42582 22.9167 10.4398 22.9167 12.5C22.9136 15.2617 21.8152 17.9095 19.8624 19.8623C17.9095 21.8152 15.2617 22.9136 12.5 22.9167Z"
          fill="black"
        />
        <path
          d="M12.4991 6.25C12.2228 6.25 11.9579 6.35975 11.7625 6.5551C11.5671 6.75045 11.4574 7.0154 11.4574 7.29167V11.7969L7.94594 13.9969C7.71112 14.1436 7.54418 14.3775 7.48187 14.6473C7.41955 14.9171 7.46695 15.2006 7.61365 15.4354C7.76035 15.6702 7.99432 15.8372 8.2641 15.8995C8.53388 15.9618 8.81737 15.9144 9.05219 15.7677L13.0522 13.2677C13.2033 13.173 13.3276 13.0411 13.4132 12.8846C13.4987 12.7281 13.5426 12.5523 13.5407 12.3739V7.29167C13.5407 7.0154 13.431 6.75045 13.2356 6.5551C13.0403 6.35975 12.7753 6.25 12.4991 6.25Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_72_1771">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ProfileAuction() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none">
      <g clipPath="url(#clip0_72_1774)">
        <path
          d="M9.33854 25H4.16667C3.0616 25 2.00179 24.561 1.22039 23.7796C0.438987 22.9982 0 21.9384 0 20.8333V15.625C0 14.5199 0.438987 13.4601 1.22039 12.6787C2.00179 11.8973 3.0616 11.4583 4.16667 11.4583H13.3927C13.9565 11.4586 14.5106 11.6044 15.0015 11.8816C15.4924 12.1588 15.9034 12.558 16.1948 13.0406L19.5458 9.35833C19.823 9.05353 20.1575 8.80634 20.5303 8.6309C20.9031 8.45545 21.3068 8.35519 21.7183 8.33584C22.1298 8.31649 22.5411 8.37844 22.9287 8.51814C23.3163 8.65784 23.6725 8.87255 23.9771 9.15C24.5848 9.70826 24.9489 10.4828 24.9912 11.3069C25.0335 12.131 24.7505 12.9387 24.2031 13.5562L17.1198 21.5115C16.1418 22.6083 14.943 23.4862 13.602 24.0874C12.261 24.6886 10.8081 24.9996 9.33854 25ZM4.16667 13.5417C3.61413 13.5417 3.08423 13.7612 2.69353 14.1519C2.30283 14.5426 2.08333 15.0725 2.08333 15.625V20.8333C2.08333 21.3859 2.30283 21.9158 2.69353 22.3065C3.08423 22.6972 3.61413 22.9167 4.16667 22.9167H9.33854C10.5135 22.9162 11.675 22.6674 12.7471 22.1867C13.8191 21.706 14.7775 21.0041 15.5594 20.1271L22.6479 12.1708C22.832 11.9635 22.9272 11.6922 22.9132 11.4154C22.8992 11.1385 22.777 10.8783 22.5729 10.6906C22.3654 10.5041 22.0934 10.4058 21.8146 10.4167C21.6764 10.4225 21.5407 10.4558 21.4155 10.5147C21.2903 10.5735 21.1781 10.6567 21.0854 10.7594L16.475 15.8333C16.2726 16.3935 15.9219 16.8882 15.4603 17.2647C14.9987 17.6411 14.4436 17.8852 13.8542 17.9708L8.47812 18.7396C8.20462 18.7788 7.92673 18.7078 7.7056 18.5421C7.48446 18.3765 7.33819 18.1298 7.29896 17.8562C7.25973 17.5827 7.33075 17.3049 7.49641 17.0837C7.66207 16.8626 7.90879 16.7163 8.18229 16.6771L13.5594 15.9094C13.8578 15.8676 14.1294 15.7142 14.3191 15.48C14.5087 15.2458 14.6025 14.9484 14.5813 14.6477C14.5602 14.3471 14.4257 14.0657 14.205 13.8604C13.9844 13.6551 13.6941 13.5412 13.3927 13.5417H4.16667ZM11.4583 9.45208C10.9862 9.45335 10.5279 9.29309 10.1594 8.99792C8.37604 7.56667 6.25 5.41667 6.25 3.33333C6.22442 2.47746 6.53883 1.6463 7.12446 1.02163C7.71009 0.396962 8.51926 0.0296377 9.375 0C10.1535 0.00303211 10.9004 0.308143 11.4583 0.851042C12.0163 0.308143 12.7632 0.00303211 13.5417 0C14.3974 0.0296377 15.2066 0.396962 15.7922 1.02163C16.3778 1.6463 16.6922 2.47746 16.6667 3.33333C16.6667 5.41667 14.5406 7.56667 12.7562 8.99896C12.3879 9.29354 11.93 9.45341 11.4583 9.45208ZM9.375 2.08333C9.07224 2.11371 8.79349 2.26169 8.5987 2.49544C8.4039 2.7292 8.30862 3.03006 8.33333 3.33333C8.33333 4.27083 9.53229 5.82292 11.4646 7.37396C13.3844 5.82292 14.5833 4.27083 14.5833 3.33333C14.608 3.03006 14.5128 2.7292 14.318 2.49544C14.1232 2.26169 13.8444 2.11371 13.5417 2.08333C13.2389 2.11371 12.9602 2.26169 12.7654 2.49544C12.5706 2.7292 12.4753 3.03006 12.5 3.33333C12.5 3.6096 12.3903 3.87455 12.1949 4.0699C11.9996 4.26525 11.7346 4.375 11.4583 4.375C11.1821 4.375 10.9171 4.26525 10.7218 4.0699C10.5264 3.87455 10.4167 3.6096 10.4167 3.33333C10.4414 3.03006 10.3461 2.7292 10.1513 2.49544C9.95651 2.26169 9.67776 2.11371 9.375 2.08333Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_72_1774">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ProfileTransfer() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none">
      <g clipPath="url(#clip0_72_1777)">
        <path
          d="M12.3231 25C12.186 25.0008 12.0501 24.9745 11.9232 24.9227C11.7963 24.8708 11.6808 24.7944 11.5835 24.6979C11.4859 24.6011 11.4084 24.4859 11.3555 24.3589C11.3026 24.232 11.2754 24.0958 11.2754 23.9583C11.2754 23.8208 11.3026 23.6847 11.3555 23.5577C11.4084 23.4308 11.4859 23.3156 11.5835 23.2187L20.0939 14.7083C20.6791 14.1224 21.0078 13.3281 21.0078 12.5C21.0078 11.6719 20.6791 10.8776 20.0939 10.2917L11.5835 1.78124C11.4864 1.68412 11.4093 1.56881 11.3568 1.44192C11.3042 1.31502 11.2772 1.17901 11.2772 1.04166C11.2772 0.764259 11.3874 0.498223 11.5835 0.302073C11.7797 0.105923 12.0457 -0.00427246 12.3231 -0.00427246C12.6005 -0.00427246 12.8665 0.105923 13.0627 0.302073L21.5731 8.81249C22.0581 9.2963 22.443 9.87104 22.7055 10.5038C22.9681 11.1366 23.1032 11.8149 23.1032 12.5C23.1032 13.1851 22.9681 13.8634 22.7055 14.4962C22.443 15.1289 22.0581 15.7037 21.5731 16.1875L13.0627 24.6979C12.9653 24.7944 12.8499 24.8708 12.723 24.9227C12.5961 24.9745 12.4602 25.0008 12.3231 25Z"
          fill="black"
        />
        <path
          d="M1.90708 25C1.76999 25.0008 1.63409 24.9745 1.50718 24.9227C1.38026 24.8708 1.26483 24.7944 1.1675 24.6979C1.06986 24.6011 0.99237 24.4859 0.939486 24.3589C0.886602 24.232 0.859375 24.0958 0.859375 23.9583C0.859375 23.8208 0.886602 23.6847 0.939486 23.5577C0.99237 23.4308 1.06986 23.3156 1.1675 23.2187L11.1571 13.2396C11.2547 13.1427 11.3322 13.0275 11.3851 12.9006C11.438 12.7737 11.4652 12.6375 11.4652 12.5C11.4652 12.3625 11.438 12.2263 11.3851 12.0994C11.3322 11.9725 11.2547 11.8572 11.1571 11.7604L1.1675 1.78124C0.971349 1.58509 0.861153 1.31905 0.861153 1.04166C0.861153 0.764259 0.971349 0.498223 1.1675 0.302073C1.36365 0.105923 1.62968 -0.00427246 1.90708 -0.00427246C2.18448 -0.00427246 2.45052 0.105923 2.64666 0.302073L12.6258 10.2917C13.211 10.8776 13.5397 11.6719 13.5397 12.5C13.5397 13.3281 13.211 14.1224 12.6258 14.7083L2.64666 24.6979C2.54933 24.7944 2.4339 24.8708 2.30698 24.9227C2.18007 24.9745 2.04417 25.0008 1.90708 25Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_72_1777">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33328)">
        <path
          d="M1.0127 30.7697L1.1077 29.4572C1.2027 28.0822 1.78895 21.0972 3.99145 18.8934C5.17712 17.7361 6.77129 17.0928 8.42815 17.1033C10.085 17.1137 11.671 17.7769 12.842 18.9491C14.013 20.1213 14.6747 21.7079 14.6835 23.3647C14.6923 25.0216 14.0475 26.6151 12.8889 27.7997C10.6864 30.0022 3.7027 30.5872 2.32395 30.6822L1.0127 30.7697ZM29.8577 1.88468C29.1282 1.18804 28.1583 0.799316 27.1496 0.799316C26.1409 0.799316 25.171 1.18804 24.4414 1.88468L11.2977 15.0334C12.5545 15.4611 13.6969 16.1704 14.6376 17.1072C15.5783 18.044 16.2923 19.1834 16.7252 20.4384L29.8577 7.29968C30.5746 6.58099 30.9772 5.6073 30.9772 4.59218C30.9772 3.57706 30.5746 2.60337 29.8577 1.88468Z"
          fill="#00BCE1"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33328">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.983398 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33331)">
        <path
          d="M30.4248 27.0498H0.424805V8.9248C0.424805 7.76448 0.885741 6.65168 1.70621 5.83121C2.52668 5.01074 3.63948 4.5498 4.7998 4.5498H26.0498C27.2101 4.5498 28.3229 5.01074 29.1434 5.83121C29.9639 6.65168 30.4248 7.76448 30.4248 8.9248V27.0498ZM4.1748 23.2998H26.6748V8.9248C26.6748 8.75904 26.609 8.60007 26.4917 8.48286C26.3745 8.36565 26.2156 8.2998 26.0498 8.2998H4.7998C4.63404 8.2998 4.47507 8.36565 4.35786 8.48286C4.24065 8.60007 4.1748 8.75904 4.1748 8.9248V23.2998ZM15.4248 19.5498C14.6831 19.5498 13.9581 19.3299 13.3414 18.9178C12.7247 18.5058 12.2441 17.9201 11.9603 17.2349C11.6764 16.5496 11.6022 15.7956 11.7469 15.0682C11.8916 14.3408 12.2487 13.6726 12.7732 13.1482C13.2976 12.6237 13.9658 12.2666 14.6932 12.1219C15.4206 11.9772 16.1746 12.0514 16.8599 12.3353C17.5451 12.6191 18.1308 13.0997 18.5428 13.7164C18.9549 14.3331 19.1748 15.0581 19.1748 15.7998C19.1748 16.7944 18.7797 17.7482 18.0765 18.4515C17.3732 19.1547 16.4194 19.5498 15.4248 19.5498ZM7.2998 9.5498C6.92896 9.5498 6.56645 9.65977 6.25811 9.8658C5.94977 10.0718 5.70944 10.3647 5.56753 10.7073C5.42562 11.0499 5.38848 11.4269 5.46083 11.7906C5.53318 12.1543 5.71176 12.4884 5.97398 12.7506C6.2362 13.0129 6.5703 13.1914 6.93401 13.2638C7.29772 13.3361 7.67472 13.299 8.01734 13.1571C8.35995 13.0152 8.65278 12.7748 8.85881 12.4665C9.06484 12.1582 9.1748 11.7956 9.1748 11.4248C9.1748 10.9275 8.97726 10.4506 8.62563 10.099C8.274 9.74735 7.79709 9.5498 7.2998 9.5498ZM21.6748 11.4248C21.6748 11.7956 21.7848 12.1582 21.9908 12.4665C22.1968 12.7748 22.4897 13.0152 22.8323 13.1571C23.1749 13.299 23.5519 13.3361 23.9156 13.2638C24.2793 13.1914 24.6134 13.0129 24.8756 12.7506C25.1379 12.4884 25.3164 12.1543 25.3888 11.7906C25.4611 11.4269 25.424 11.0499 25.2821 10.7073C25.1402 10.3647 24.8998 10.0718 24.5915 9.8658C24.2832 9.65977 23.9206 9.5498 23.5498 9.5498C23.0525 9.5498 22.5756 9.74735 22.224 10.099C21.8723 10.4506 21.6748 10.9275 21.6748 11.4248ZM7.2998 18.2998C6.92896 18.2998 6.56645 18.4098 6.25811 18.6158C5.94977 18.8218 5.70944 19.1147 5.56753 19.4573C5.42562 19.7999 5.38848 20.1769 5.46083 20.5406C5.53318 20.9043 5.71176 21.2384 5.97398 21.5006C6.2362 21.7629 6.5703 21.9414 6.93401 22.0138C7.29772 22.0861 7.67472 22.049 8.01734 21.9071C8.35995 21.7652 8.65278 21.5248 8.85881 21.2165C9.06484 20.9082 9.1748 20.5456 9.1748 20.1748C9.1748 19.6775 8.97726 19.2006 8.62563 18.849C8.274 18.4973 7.79709 18.2998 7.2998 18.2998ZM21.6748 20.1748C21.6748 20.5456 21.7848 20.9082 21.9908 21.2165C22.1968 21.5248 22.4897 21.7652 22.8323 21.9071C23.1749 22.049 23.5519 22.0861 23.9156 22.0138C24.2793 21.9414 24.6134 21.7629 24.8756 21.5006C25.1379 21.2384 25.3164 20.9043 25.3888 20.5406C25.4611 20.1769 25.424 19.7999 25.2821 19.4573C25.1402 19.1147 24.8998 18.8218 24.5915 18.6158C24.2832 18.4098 23.9206 18.2998 23.5498 18.2998C23.0525 18.2998 22.5756 18.4973 22.224 18.849C21.8723 19.2006 21.6748 19.6775 21.6748 20.1748Z"
          fill="#DF508B"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33331">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.424805 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33334)">
        <path
          d="M30.4377 22.2545L25.904 17.7208V21.3945C22.941 21.1996 20.1718 19.8537 18.1877 17.6445C17.9377 17.9308 17.6877 18.2145 17.4277 18.5195C16.879 19.1545 16.3027 19.812 15.709 20.4683C18.3739 23.2886 22.0281 24.9665 25.904 25.1495V28.7358L30.4377 24.202C30.5659 24.0743 30.6675 23.9225 30.7369 23.7554C30.8062 23.5883 30.8419 23.4092 30.8419 23.2283C30.8419 23.0474 30.8062 22.8682 30.7369 22.7011C30.6675 22.534 30.5659 22.3823 30.4377 22.2545Z"
          fill="#81C041"
        />
        <path
          d="M25.8811 10.1936V13.8186L30.4336 9.26607C30.6928 9.00681 30.8384 8.6552 30.8384 8.28857C30.8384 7.92195 30.6928 7.57034 30.4336 7.31107L25.8811 2.75732V6.43857C20.2236 6.70107 16.8148 9.78107 13.9773 12.9511C10.9486 9.59982 7.26609 6.40857 0.839844 6.40857V10.1648C5.95109 10.1648 8.70234 12.6573 11.4898 15.8011C8.70234 18.9448 5.95109 21.4348 0.839844 21.4348V25.1911C8.39859 25.1911 12.1661 20.7748 15.5323 16.8773C18.4911 13.4573 21.0673 10.4848 25.8811 10.1936Z"
          fill="#81C041"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33334">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.866211 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon4() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33337)">
        <path
          d="M30.3076 24.5498V5.1748C30.3076 4.01448 29.8467 2.90168 29.0262 2.08121C28.2057 1.26074 27.0929 0.799805 25.9326 0.799805H4.68262C3.52229 0.799805 2.4095 1.26074 1.58903 2.08121C0.768553 2.90168 0.307617 4.01448 0.307617 5.1748L0.307617 24.5498H13.4326V27.0498H7.80762V30.7998H22.8076V27.0498H17.1826V24.5498H30.3076ZM4.05762 5.1748C4.05762 5.00904 4.12347 4.85007 4.24068 4.73286C4.35789 4.61565 4.51686 4.5498 4.68262 4.5498H25.9326C26.0984 4.5498 26.2573 4.61565 26.3746 4.73286C26.4918 4.85007 26.5576 5.00904 26.5576 5.1748V20.7998H4.05762V5.1748ZM18.6826 10.7998H24.0576V14.5498H20.6826L16.9464 20.1536L13.1964 12.6536L11.9326 14.5498H6.55762V10.7998H9.93262L13.6689 5.19605L17.4189 12.6961L18.6826 10.7998Z"
          fill="#28245F"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33337">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.307617 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon5() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33344)">
        <path
          d="M25.0824 29.9437L15.7487 23.0837L6.41492 29.9437L9.99867 18.8649L0.669922 12.0487H12.1874L15.7487 0.951172L19.3099 12.0487H30.8262L21.4987 18.8649L25.0824 29.9437Z"
          fill="#BF8D2C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33344">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.749023 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon6() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33352)">
        <path
          d="M27.6895 23.5295V20.7995C27.6895 19.8049 27.2944 18.8511 26.5911 18.1479C25.8878 17.4446 24.934 17.0495 23.9395 17.0495H16.4395V13.1745C17.957 12.8647 19.3055 12.0025 20.2235 10.755C21.1414 9.50752 21.5635 7.9636 21.4078 6.4226C21.2521 4.8816 20.5298 3.45329 19.3809 2.41458C18.232 1.37588 16.7383 0.800781 15.1895 0.800781C13.6406 0.800781 12.1469 1.37588 10.998 2.41458C9.8491 3.45329 9.12678 4.8816 8.97111 6.4226C8.81544 7.9636 9.2375 9.50752 10.1555 10.755C11.0734 12.0025 12.4219 12.8647 13.9395 13.1745V17.0495H6.43946C5.4449 17.0495 4.49107 17.4446 3.78781 18.1479C3.08455 18.8511 2.68946 19.8049 2.68946 20.7995V23.5295C1.85544 23.8244 1.15252 24.4046 0.704921 25.1676C0.257325 25.9306 0.0938772 26.8273 0.243466 27.6992C0.393055 28.571 0.84605 29.362 1.52239 29.9321C2.19872 30.5023 3.05485 30.815 3.93946 30.815C4.82407 30.815 5.6802 30.5023 6.35654 29.9321C7.03287 29.362 7.48587 28.571 7.63546 27.6992C7.78504 26.8273 7.6216 25.9306 7.174 25.1676C6.7264 24.4046 6.02348 23.8244 5.18946 23.5295V20.7995C5.18946 20.468 5.32116 20.15 5.55558 19.9156C5.79 19.6812 6.10794 19.5495 6.43946 19.5495H13.9395V23.5295C13.1054 23.8244 12.4025 24.4046 11.9549 25.1676C11.5073 25.9306 11.3439 26.8273 11.4935 27.6992C11.6431 28.571 12.0961 29.362 12.7724 29.9321C13.4487 30.5023 14.3049 30.815 15.1895 30.815C16.0741 30.815 16.9302 30.5023 17.6065 29.9321C18.2829 29.362 18.7359 28.571 18.8855 27.6992C19.035 26.8273 18.8716 25.9306 18.424 25.1676C17.9764 24.4046 17.2735 23.8244 16.4395 23.5295V19.5495H23.9395C24.271 19.5495 24.5889 19.6812 24.8233 19.9156C25.0578 20.15 25.1895 20.468 25.1895 20.7995V23.5295C24.3554 23.8244 23.6525 24.4046 23.2049 25.1676C22.7573 25.9306 22.5939 26.8273 22.7435 27.6992C22.8931 28.571 23.346 29.362 24.0224 29.9321C24.6987 30.5023 25.5549 30.815 26.4395 30.815C27.3241 30.815 28.1802 30.5023 28.8565 29.9321C29.5329 29.362 29.9859 28.571 30.1355 27.6992C30.285 26.8273 30.1216 25.9306 29.674 25.1676C29.2264 24.4046 28.5235 23.8244 27.6895 23.5295Z"
          fill="#00BCE1"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33352">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.189453 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon7() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33356)">
        <path
          d="M30.631 15.7999C30.6302 12.4717 29.5161 9.2393 27.466 6.61742L29.4572 4.62617L26.8047 1.97367L24.8135 3.96492C22.192 1.91405 18.9594 0.799805 15.631 0.799805C12.3026 0.799805 9.06997 1.91405 6.44847 3.96492L4.45722 1.97367L1.80472 4.62617L3.79597 6.61742C1.74511 9.23891 0.630859 12.4715 0.630859 15.7999C0.630859 19.1283 1.74511 22.3609 3.79597 24.9824L1.80472 26.9737L4.45722 29.6262L6.44847 27.6349C9.06997 29.6858 12.3026 30.8 15.631 30.8C18.9594 30.8 22.192 29.6858 24.8135 27.6349L26.8047 29.6262L29.4572 26.9737L27.466 24.9824C29.5161 22.3605 30.6302 19.1282 30.631 15.7999ZM26.881 15.7999C26.8809 18.1341 26.15 20.4097 24.791 22.3074L21.4435 18.9612C21.9908 17.9975 22.2785 16.9082 22.2785 15.7999C22.2785 14.6916 21.9908 13.6024 21.4435 12.6387L24.791 9.29242C26.15 11.1902 26.8809 13.4657 26.881 15.7999ZM12.7335 15.7999C12.7335 15.2268 12.9034 14.6666 13.2218 14.1902C13.5402 13.7137 13.9927 13.3423 14.5221 13.123C15.0516 12.9037 15.6342 12.8463 16.1962 12.9581C16.7583 13.0699 17.2746 13.3459 17.6798 13.7511C18.085 14.1563 18.361 14.6726 18.4728 15.2346C18.5846 15.7967 18.5272 16.3793 18.3079 16.9087C18.0886 17.4382 17.7172 17.8907 17.2407 18.2091C16.7642 18.5275 16.204 18.6974 15.631 18.6974C14.8628 18.6964 14.1264 18.3908 13.5832 17.8477C13.0401 17.3045 12.7345 16.5681 12.7335 15.7999ZM15.631 4.54992C17.9652 4.55002 20.2407 5.28087 22.1385 6.63992L18.7922 9.98742C17.8285 9.4401 16.7392 9.15236 15.631 9.15236C14.5227 9.15236 13.4334 9.4401 12.4697 9.98742L9.12347 6.63992C11.0212 5.28087 13.2968 4.55002 15.631 4.54992ZM4.38097 15.7999C4.38108 13.4657 5.11192 11.1902 6.47097 9.29242L9.81847 12.6387C9.27116 13.6024 8.98342 14.6916 8.98342 15.7999C8.98342 16.9082 9.27116 17.9975 9.81847 18.9612L6.47097 22.3074C5.11192 20.4097 4.38108 18.1341 4.38097 15.7999ZM15.631 27.0499C13.2968 27.0498 11.0212 26.319 9.12347 24.9599L12.4697 21.6124C13.4334 22.1597 14.5227 22.4475 15.631 22.4475C16.7392 22.4475 17.8285 22.1597 18.7922 21.6124L22.1385 24.9599C20.2407 26.319 17.9652 27.0498 15.631 27.0499Z"
          fill="#DF508B"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33356">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.630859 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon8() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33360)">
        <path
          d="M18.0898 17.0498L26.5211 25.481C28.5353 23.1035 29.7552 20.1554 30.0098 17.0498H18.0898Z"
          fill="#81C041"
        />
        <path
          d="M14.188 16.6836L13.8218 16.3173V0.862305C11.4665 1.05531 9.19022 1.80205 7.17832 3.04169C5.16642 4.28132 3.47588 5.97876 2.24444 7.99569C1.01301 10.0126 0.275539 12.292 0.0921259 14.648C-0.0912877 17.004 0.284547 19.37 1.189 21.5532C2.09346 23.7364 3.50094 25.675 5.29675 27.2111C7.09257 28.7472 9.2259 29.8372 11.5229 30.3924C13.8199 30.9475 16.2156 30.9522 18.5147 30.4058C20.8138 29.8595 22.9513 28.7777 24.753 27.2486L14.188 16.6836Z"
          fill="#81C041"
        />
        <path
          d="M16.3232 14.5498H30.0107C29.7157 11.0184 28.1788 7.70578 25.673 5.2C23.1673 2.69421 19.8546 1.15738 16.3232 0.862305V14.5498Z"
          fill="#81C041"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33360">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.0722656 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon9() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33364)">
        <path
          d="M20.5674 18.3003H10.4599C8.81718 18.3023 7.2423 18.9557 6.0807 20.1173C4.91911 21.2789 4.26566 22.8538 4.26367 24.4965V30.8003H26.7637V24.4965C26.7617 22.8538 26.1082 21.2789 24.9466 20.1173C23.785 18.9557 22.2102 18.3023 20.5674 18.3003Z"
          fill="#28245F"
        />
        <path
          d="M15.5137 15.7998C19.6558 15.7998 23.0137 12.4419 23.0137 8.2998C23.0137 4.15767 19.6558 0.799805 15.5137 0.799805C11.3715 0.799805 8.01367 4.15767 8.01367 8.2998C8.01367 12.4419 11.3715 15.7998 15.5137 15.7998Z"
          fill="#28245F"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33364">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.513672 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon10() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33368)">
        <path
          d="M9.70507 30.8008C11.0858 30.8008 12.2051 29.6815 12.2051 28.3008C12.2051 26.9201 11.0858 25.8008 9.70507 25.8008C8.32436 25.8008 7.20508 26.9201 7.20508 28.3008C7.20508 29.6815 8.32436 30.8008 9.70507 30.8008Z"
          fill="#BF8D2C"
        />
        <path
          d="M22.2051 30.8008C23.5858 30.8008 24.7051 29.6815 24.7051 28.3008C24.7051 26.9201 23.5858 25.8008 22.2051 25.8008C20.8244 25.8008 19.7051 26.9201 19.7051 28.3008C19.7051 29.6815 20.8244 30.8008 22.2051 30.8008Z"
          fill="#BF8D2C"
        />
        <path
          d="M8.02258 7.0498L7.69383 4.4723C7.57446 3.46067 7.08805 2.528 6.32683 1.8511C5.56561 1.1742 4.58248 0.800132 3.56383 0.799805L0.955078 0.799805V4.5498H3.56383C3.66609 4.5509 3.76432 4.58983 3.83957 4.65908C3.91482 4.72833 3.96176 4.82299 3.97133 4.9248L5.84633 19.6236C5.96459 20.636 6.45055 21.5697 7.21191 22.2474C7.97328 22.9251 8.95703 23.2996 9.97633 23.2998H26.4551L30.9226 7.0498H8.02258ZM23.5951 19.5498H9.97633C9.87412 19.549 9.77589 19.5101 9.70079 19.4408C9.62568 19.3714 9.57909 19.2766 9.57008 19.1748L8.50133 10.7998H26.0013L23.5951 19.5498Z"
          fill="#BF8D2C"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33368">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.955078 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CarouselIcon11() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none">
      <g clipPath="url(#clip0_7451_33372)">
        <path
          d="M15.3966 2.04932C12.221 2.04796 9.12759 3.05914 6.56588 4.93594C4.00417 6.81275 2.10756 9.45743 1.15159 12.4858C0.195613 15.5141 0.230067 18.7684 1.24994 21.7758C2.26982 24.7832 4.22199 27.3872 6.82286 29.2093L7.30661 29.5493H23.4866L23.9704 29.2093C26.5712 27.3872 28.5234 24.7832 29.5433 21.7758C30.5632 18.7684 30.5976 15.5141 29.6416 12.4858C28.6857 9.45743 26.7891 6.81275 24.2273 4.93594C21.6656 3.05914 18.5723 2.04796 15.3966 2.04932ZM22.2716 25.7993H8.52161C6.68301 24.3671 5.3376 22.3964 4.67326 20.1625C4.00892 17.9286 4.05882 15.543 4.816 13.3389C5.57318 11.1347 6.99983 9.22202 8.89672 7.86795C10.7936 6.51389 13.066 5.78603 15.3966 5.78603C17.7272 5.78603 19.9996 6.51389 21.8965 7.86795C23.7934 9.22202 25.22 11.1347 25.9772 13.3389C26.7344 15.543 26.7843 17.9286 26.12 20.1625C25.4556 22.3964 24.1102 24.3671 22.2716 25.7993ZM17.8829 17.1481C17.8664 17.6288 17.7116 18.0947 17.437 18.4896C17.1624 18.8846 16.7797 19.192 16.3347 19.3749C15.8898 19.5577 15.4015 19.6084 14.9285 19.5207C14.4556 19.433 14.0179 19.2107 13.6681 18.8804C13.3183 18.5502 13.0712 18.126 12.9565 17.6589C12.8417 17.1917 12.8642 16.7013 13.0212 16.2466C13.1782 15.7919 13.4631 15.3921 13.8416 15.0953C14.2202 14.7985 14.6763 14.6171 15.1554 14.5731L19.6554 10.0668L22.3066 12.7181L17.8829 17.1481ZM12.5291 21.1393L10.3729 24.2093C8.73588 23.0745 7.53605 21.4141 6.97241 19.5037C6.40877 17.5932 6.5152 15.5475 7.27405 13.7058C8.03289 11.8642 9.39854 10.3373 11.1445 9.37846C12.8904 8.41963 14.9116 8.0865 16.8729 8.43432L11.6579 13.7631C11.1902 14.2869 10.8392 14.9041 10.6281 15.5738C10.417 16.2435 10.3506 16.9504 10.4334 17.6478C10.5161 18.3451 10.746 19.0168 11.108 19.6185C11.4699 20.2203 11.9556 20.7382 12.5329 21.1381L12.5291 21.1393ZM24.1466 17.0493C24.1446 18.454 23.8051 19.8376 23.1566 21.0837C22.5081 22.3297 21.5697 23.4017 20.4204 24.2093L18.2641 21.1393C18.6591 20.8618 23.9941 15.4593 23.9941 15.4593C24.0938 15.9835 24.1449 16.5157 24.1466 17.0493Z"
          fill="#00BCE1"
        />
      </g>
      <defs>
        <clipPath id="clip0_7451_33372">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.396484 0.799805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RemoveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none">
      <path
        d="M2 4.5H3.33333H14"
        stroke="#FF0000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6663 4.49967V13.833C12.6663 14.1866 12.5259 14.5258 12.2758 14.7758C12.0258 15.0259 11.6866 15.1663 11.333 15.1663H4.66634C4.31272 15.1663 3.97358 15.0259 3.72353 14.7758C3.47348 14.5258 3.33301 14.1866 3.33301 13.833V4.49967M5.33301 4.49967V3.16634C5.33301 2.81272 5.47348 2.47358 5.72353 2.22353C5.97358 1.97348 6.31272 1.83301 6.66634 1.83301H9.33301C9.68663 1.83301 10.0258 1.97348 10.2758 2.22353C10.5259 2.47358 10.6663 2.81272 10.6663 3.16634V4.49967"
        stroke="#FF0000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 7.83301V11.833"
        stroke="#FF0000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 7.83301V11.833"
        stroke="#FF0000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AddFamilyPlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none">
      <path
        d="M12.5 5V19"
        stroke="#28245F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 12H19.5"
        stroke="#28245F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function OpenCampaignIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M19.1667 9.16602H0.833333C0.373096 9.16602 0 9.53911 0 9.99935C0 10.4596 0.373096 10.8327 0.833333 10.8327H19.1667C19.6269 10.8327 20 10.4596 20 9.99935C20 9.53911 19.6269 9.16602 19.1667 9.16602Z"
        fill="black"
      />
    </svg>
  );
}

export function CloseCampaignIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <g clipPath="url(#clip0_7787_15527)">
        <path
          d="M19.1667 9.16667H10.8333V0.833333C10.8333 0.61232 10.7455 0.400358 10.5893 0.244078C10.433 0.0877974 10.221 0 10 0C9.77899 0 9.56702 0.0877974 9.41074 0.244078C9.25446 0.400358 9.16667 0.61232 9.16667 0.833333V9.16667H0.833333C0.61232 9.16667 0.400358 9.25446 0.244078 9.41074C0.0877974 9.56702 0 9.77899 0 10C0 10.221 0.0877974 10.433 0.244078 10.5893C0.400358 10.7455 0.61232 10.8333 0.833333 10.8333H9.16667V19.1667C9.16667 19.3877 9.25446 19.5996 9.41074 19.7559C9.56702 19.9122 9.77899 20 10 20C10.221 20 10.433 19.9122 10.5893 19.7559C10.7455 19.5996 10.8333 19.3877 10.8333 19.1667V10.8333H19.1667C19.3877 10.8333 19.5996 10.7455 19.7559 10.5893C19.9122 10.433 20 10.221 20 10C20 9.77899 19.9122 9.56702 19.7559 9.41074C19.5996 9.25446 19.3877 9.16667 19.1667 9.16667Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_7787_15527">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SelectedItemsCancle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none">
      <path
        d="M10.9122 4.41272L10.0874 3.58789L6.99982 6.67547L3.91224 3.58789L3.0874 4.41272L6.17499 7.50031L3.0874 10.5879L3.91224 11.4127L6.99982 8.32514L10.0874 11.4127L10.9122 10.5879L7.82465 7.50031L10.9122 4.41272Z"
        fill="white"
      />
    </svg>
  );
}

export function NotificationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16">
      <path
        fill="#28245f"
        d="M8 1.5c-1.736 0-3.369.676-4.596 1.904S1.5 6.264 1.5 8c0 1.736.676 3.369 1.904 4.596S6.264 14.5 8 14.5c1.736 0 3.369-.676 4.596-1.904S14.5 9.736 14.5 8c0-1.736-.676-3.369-1.904-4.596S9.736 1.5 8 1.5M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M7 11h2v2H7zm0-8h2v6H7z"
      />
    </svg>
  );
}

//clipPath
